import {Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, ChangeDetectorRef, OnDestroy, AfterViewInit, OnChanges, SimpleChanges} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {Router, ActivatedRoute} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as Feather from 'feather-icons';
import flatpickr from 'flatpickr';
import {French} from 'flatpickr/dist/l10n/fr.js';
import {DetailVenteComponent} from '../Vente/devis/detail-vente/detail-vente.component';
import {FileUploadModalComponent} from '../Vente/devis/parametre-bar/file-upload-modal/file-upload-modal.component';
import {ConvertModalComponent} from '../Vente/devis/convert-modal/convert-modal.component';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {Subscription, BehaviorSubject, Observable, of, forkJoin} from 'rxjs';
import {first, map, catchError, mergeMap} from 'rxjs/operators';
import {ExportService} from './export.service';
import {getHtml2CanvasOptionsForDocumentExport, saveCanvasAsPdfDocument} from './document-pdf-export.util';
import {DataService, Quote, ClientOrder, Facture, BonSortie, BonLivraison} from '../../../services/commande-client/data.service';
import {PaiementFactureComponent} from '../Vente/facture/paiement-facture/paiement-facture.component';
import {SmsModalComponent} from '../Vente/commande-client/sms-modal/sms-modal.component';
import {ApercueComponent} from './apercue/apercue.component';
import {AchatService, CommandeFournisseur} from '../../../services/achat/achat.service';
import {DetailCmdFournissComponent} from '../Achat/cmd-fournisseur/detail-cmd-fourniss/detail-cmd-fourniss.component';
import {DetailInventaireComponent} from '../stock/inventaire/detail-inventaire/detail-inventaire.component';
import {EmailComposeComponent} from '../Vente/devis/parametre-bar/email-compose/email-compose.component';
import {DocumentService} from '../../../services/document/document.service';
import {isAvoirTableRow, isFactureTableRowExcludingAvoirs} from '../../../services/document/document-avoir-row.util';
import {ModalRightService} from '../../../services/modal-right/modal-right.service';
import {DocumentPreviewService} from '../../../services/document/document-preview.service';
import {ClientService} from '../../../services/Client/client.service';
import {FournisseurService} from '../../../services/Fournisseur/fournisseur.service';
import {ProjetService} from '../../../services/projet.service';
import {StationService} from '../../../services/station.service';
import {WarehouseService} from '../../../services/warehouse/warehouse.service';
import {Client} from '../../../models/client';
import {Fournisseur} from '../../../models/fournisseur';
import {Project} from '../../../models/project';
import {getStationIdFromLocalStorage} from '../../../services/parametre-document/parametre-document-state.service';
import {resolveEnterpriseDisplayName} from '../../../services/enterprise-context';
import {
    saveDocumentDateFilter,
    DocumentDateViewMode,
} from '../../../services/document-date-filter.storage';
import { DocumentListLoadingService } from '../../../services/document-list-loading.service';
import {
    formatLocalDateKey,
    todayLocalDateKey,
} from '../../../services/logiciel-caisse/logiciel-caisse-api.helper';
import { LogicielCaisseAuthService } from '../../../services/logiciel-caisse/logiciel-caisse-auth.service';
import { LogicielCaisseTicketService } from '../../../services/logiciel-caisse/logiciel-caisse-ticket.service';
import {
    FactureListDisplayService,
    FactureListDisplaySettings,
} from '../../../services/facture/facture-list-display.service';

@Component({
    selector: 'app-shared',
    templateUrl: './shared.component.html',
    styleUrls: ['./shared.component.scss']
})
export class SharedComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    @Input() status: string = 'Tous';
    @Input() type: 'devis' | 'commande-client' | 'bon-livraison' | 'facture' | 'avoir' | 'bon-sortie' | 'commande-fournisseur' | 'bon-reception' | 'facture-fournisseur' | 'retour-fournisseur' | 'avoir-fournisseur' | 'inventaire' | 'bon-transfert' | undefined;
    @Input() fournisseurScopeId: number | string | null = null;
    private clientDetailsScopeClientId: number | null = null;
    private clientDetailsScopeResolveSub: Subscription | null = null;

    get isClientDetailsDocumentScope(): boolean {
        return this.clientDetailsScopeClientId != null;
    }
    @ViewChild('filterPanelVente') filterPanelVente!: ElementRef;
    @ViewChild('filterPanelAchat') filterPanelAchat!: ElementRef;
    @ViewChild('filterPanelStock') filterPanelStock!: ElementRef;
    @ViewChild('phoneModal') phoneModal!: TemplateRef<any>;
    @ViewChild('redirectModal') redirectModal!: TemplateRef<any>;
    @ViewChild('datePicker') datePicker!: ElementRef;
    @ViewChild('dateDuVente') dateDuVente!: ElementRef;
    @ViewChild('dateJusquaVente') dateJusquaVente!: ElementRef;
    @ViewChild('dateDuAchat') dateDuAchat!: ElementRef;
    @ViewChild('dateJusquaAchat') dateJusquaAchat!: ElementRef;
    @ViewChild('dateDuStock') dateDuStock!: ElementRef;
    @ViewChild('dateJusquaStock') dateJusquaStock!: ElementRef;
    @ViewChild('table') table!: ElementRef;
    @ViewChild('detailVente') detailVenteComponent!: DetailVenteComponent;
    @ViewChild('uploadModal') fileUploadModal!: FileUploadModalComponent;
    @ViewChild('convertModal') convertModal!: ConvertModalComponent;
    @ViewChild('paiementFacture') paiementFacture!: PaiementFactureComponent;
    @ViewChild('apercueModal', {static: false}) apercueModal!: ApercueComponent;
    @ViewChild(SmsModalComponent) smsModalComponent!: SmsModalComponent;
    @ViewChild('detailCommandeFournisseurModal') detailCommandeFournisseurModal!: DetailCmdFournissComponent;
    @ViewChild('detailInventaireModal') detailInventaireModal!: DetailInventaireComponent;
    @ViewChild('emailCompose') emailComposeComponent?: EmailComposeComponent;
    isLoading: boolean = true;
    isExportingPDF = false;
    isApercuVisible = false;
    expandedRowId: number | null = null;
    expandedDocument: any = null;
    isLoadingExpanded = false;
    viewMode: 'jours' | 'mois' | 'annees' = 'jours';
    weekDays: { label: string; dateString: string; isToday: boolean }[] = [];
    currentMonthIndex = new Date().getMonth();
    currentYear = new Date().getFullYear();
    selectedMonthIndex: number | null = null;
    selectedDay: string = '';
    selectedYear: number | null = null;
    selectedDate: Date | null = null;
    selectedPeriod = '';
    dateFilterStart: string = '';
    dateFilterEnd: string = '';
    months = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];
    years: number[] = [];
    archiveData: (Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur)[] = [];
    filteredData: (Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur)[] = [];
    paginatedData: (Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur)[] = [];
    hasDataLoaded: boolean = false;
    searchTerm = '';
    showFilter = false;
    showFilterAchat = false;
    selectedItem: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur | null = null;
    selectedItemForEmail: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur | null = null;
    basicSelectedOption = 10;
    currentPage = 1;
    totalPages = 1;
    pages: number[] = [];
    filterSummary = '';
    typeAchat = ['Tous', 'Crée', 'Valide', 'Annulé', 'Converti', 'Non converti', 'Reçu', 'Payé', 'Non payé'];
    statuses: string[] = [];
    filters: any = {
        raison: '',
        matricule: '',
        chiffre_aff: '',
        operator: '=',
        client_id: null,
        fournisseur_id: null,
        projet_id: null,
        entrepot_id: null,
        date_du: '',
        date_jusqua: '',
        selectedStatuses: []
    };

    private modalRef: NgbModalRef | null = null;
    private dataSubscription: Subscription | null = null;
    private pdfExportSubscription: Subscription | null = null;
    isBlurRemoved: boolean = false;
    totalFactureTTC: number = 0;
    totalFactureHTC: number = 0;
    totalFacturePaye: number = 0;
    totalFactureAPaye: number = 0;
    totalFactureRetard: number = 0;
    statsFacturesGlobales: {
        data: {
            total_ht: number;
            total_ttc: number;
            factures_payees: { nombre: number; total_ttc: number };
            factures_a_payer: {
                nombre: number;
                total_ttc: number;
                detail: {
                    factures_non_payees: { nombre: number; total_ttc: number };
                    montant_restant_factures_partiellement_payees: { nombre: number; montant_restant: number };
                };
            };
            factures_partiellement_payees?: { nombre: number; total_ttc: number; montant_restant: number };
            total_factures: number;
        };
    } | null = null;
    statsFacturesFournisseurGlobales: {
        data: {
            total_ht: number;
            total_ttc: number;
            factures_payees: { nombre: number; total_ttc: number };
            factures_a_payer: {
                nombre: number;
                total_ttc: number;
                detail: {
                    factures_non_payees: { nombre: number; total_ttc: number };
                    montant_restant_factures_partiellement_payees: { nombre: number; montant_restant: number };
                };
            };
            factures_partiellement_payees?: { nombre: number; total_ttc: number; montant_restant: number };
            total_factures: number;
        };
    } | null = null;
    baseRoute: string = '/vente';
    selectedDocumentFull: any = null;
    isLoadingDocument = false;
    conversionResult: {documentId: number, newType: string} | null = null;
    clients: Client[] = [];
    fournisseurs: Fournisseur[] = [];
    projects: Project[] = [];
    entrepots: any[] = [];
    isLoadingClients = false;
    isLoadingFournisseurs = false;
    isLoadingProjects = false;
    isLoadingEntrepots = false;
    stationId: number = 0;
    /** Utilisateur connecté (filtrage API inventaire / bon-transfert). */
    userId: number = 0;
    stationData: any = null;
    entrepotsCache: Map<number, string> = new Map();
    factureIdsWithAvoirNonPaye = new Set<number>();
    factureIdsWithTicketsConsolides = new Set<number>();
    private readonly STATUT_AVOIR_NON_UTILISE = 19;
    private readonly STATUT_AVOIR_PARTIELLEMENT_UTILISE = 20;
    skeletonRows = [0, 1, 2, 3, 4];
    private erpFactureLinksSub: Subscription | null = null;
    private factureListDisplaySub: Subscription | null = null;
    factureListDisplay: FactureListDisplaySettings | null = null;

    constructor(
        private toastr: ToastrService,
        private dataService: DataService,
        private achatService: AchatService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private exportService: ExportService,
        private documentService: DocumentService,
        private customizerService: ModalRightService,
        private documentPreviewService: DocumentPreviewService,
        private clientService: ClientService,
        private fournisseurService: FournisseurService,
        private projetService: ProjetService,
        private stationService: StationService,
        private warehouseService: WarehouseService,
        public listLoading: DocumentListLoadingService,
        private lcTicketService: LogicielCaisseTicketService,
        private lcAuthService: LogicielCaisseAuthService,
        private factureListDisplayService: FactureListDisplayService
    ) {
    }

    get isTableLoading(): boolean {
        return this.isLoading || this.listLoading.isLoading;
    }

    ngOnInit() {
        this.loadUserData();
        setTimeout(() => {
            this.loadStationData();
        }, 100);
        this.updateBaseRoute();
        this.initClientDetailsDocumentScope();
        if (!this.type) {
            const url = this.router.url;
            if (url.includes('achat/avoir-fournisseur')) {
                this.type = 'avoir-fournisseur';
            } else if (url.includes('vente-negoce/avoir')) {
                this.type = 'avoir';
            } else if (url.includes('vente/avoir')) {
                this.type = 'avoir';
            } else if (url.includes('retour-fournisseur')) {
                this.type = 'retour-fournisseur';
            } else if (url.includes('facture-fournisseur')) {
                this.type = 'facture-fournisseur';
            } else if (url.includes('commande-fournisseur')) {
                this.type = 'commande-fournisseur';
            } else if (url.includes('bon-reception')) {
                this.type = 'bon-reception';
            } else if (url.includes('commande-client')) {
                this.type = 'commande-client';
            } else if (url.includes('bon-livraison')) {
                this.type = 'bon-livraison';
            } else if (url.includes('bon-sortie')) {
                this.type = 'bon-sortie';
            } else if (url.includes('facture')) {
                this.type = 'facture';
            } else if (url.includes('devis')) {
                this.type = 'devis';
            } else if (url.includes('inventaire')) {
                this.type = 'inventaire';
            } else if (url.includes('bon-transfert')) {
                this.type = 'bon-transfert';
        } else {
            this.type = 'devis';
        }
    }

        this.pdfExportSubscription = this.exportService.triggerPDFExport$.subscribe(() => this.downloadPDF());

        switch (this.type) {
            case 'devis':
                this.statuses = ['Tous', 'Brouillon', 'Crée', 'Annulé', 'Négociation', 'Accepté'];
                break;
            case 'commande-client':
                this.statuses = ['Tous', 'Brouillon', 'Valide', 'Crée', 'Annulé'];
                break;
            case 'facture':
                this.statuses = ['Tous', 'Brouillon', 'Payé', 'Non payé', 'Annulée'];
                break;
            case 'avoir':
                this.statuses = ['Tous', 'Brouillon', 'Non utilisé', 'Partiellement utilisé', 'Utilisé', 'Annulé'];
                break;
            case 'bon-livraison':
                this.statuses = ['Tous', 'Brouillon', 'Crée', 'Livré', 'Annulé'];
                break;
            case 'bon-sortie':
                this.statuses = ['Tous', 'Brouillon', 'Crée', 'Annulé','Fermé'];
                break;
            case 'commande-fournisseur':
                this.statuses = ['Tous', 'Brouillon', 'Valide', 'Crée', 'Annulé'];
                break;
            case 'bon-reception':
                this.statuses = ['Tous', 'Brouillon', 'Crée', 'Annulé', 'Reçu'];
                break;
            case 'facture-fournisseur':
                this.statuses = ['Tous', 'Brouillon', 'Payé', 'Non payé', 'Annulé'];
                break;
            case 'retour-fournisseur':
                this.statuses = ['Tous', 'Brouillon', 'Payé', 'Non payé', 'Annulé'];
                break;
            case 'avoir-fournisseur':
                this.statuses = ['Tous', 'Brouillon', 'Non utilisé', 'Partiellement utilisé', 'Utilisé', 'Annulé'];
                break;
            case 'inventaire':
                this.statuses = ['Tous', 'Brouillon', 'Crée', 'Annulé'];
                break;
            case 'bon-transfert':
                this.statuses = ['Tous', 'Brouillon', 'Crée', 'Annulé'];
                break;
            default:
                this.statuses = ['Tous'];
        }

        const today = new Date();
        this.currentMonthIndex = today.getMonth();
        this.currentYear = today.getFullYear();
        this.restoreDateFilterState();
        this.years = Array.from({length: 10}, (_, i) => this.currentYear - i).reverse();
        this.isLoading = true;
        this.filterByStatus(this.status);
        if (this.type === 'inventaire' || this.type === 'bon-transfert') {
            // loadStockDocuments déjà déclenché par filterByStatus
        } else {
            const dataObservable = this.getDataObservable();
            this.dataSubscription = dataObservable.subscribe({
                next: (data) => {
                    const raw = data || [];
                    const filtered = this.applyTypeFilterForArchive(raw);
                    this.archiveData = this.deduplicateDocumentsById(filtered);
                    this.updateFilteredData();
                    this.calculateFactureTotals();
                    if (this.type === 'facture') {
                        this.loadStatsFacturesGlobales();
                    }
                    if (this.type === 'facture-fournisseur') {
                        this.loadStatsFacturesFournisseurGlobales();
                    }
                    if (this.type === 'facture' || this.type === 'facture-fournisseur' || this.type === 'retour-fournisseur') {
                        this.loadFactureIdsWithAvoirNonPaye();
                    }
                    this.isLoading = false;
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.hasDataLoaded = true;
                    this.isLoading = false;
                    this.toastr.error('Erreur lors du chargement des données', 'Erreur');
                    this.cdr.detectChanges();
                }
            });
            /** Pas de second chargement ici : filterByStatus() ci-dessus a déjà déclenché load (fournisseur ou global). */
        }
        
        this.customizerService.isCustomizerOpen$.subscribe(isOpen => {
            if (!isOpen && this.isApercuVisible) {
                this.closeApercu();
            }
        });
        this.loadFournisseurs();
        this.loadProjects();
        if (this.baseRoute === '/vente') {
            this.loadClients();
        }
        if (this.type === 'inventaire') {
            this.loadEntrepots();
        }
        if (this.type === 'facture') {
            this.factureListDisplayService.loadForUser(this.userId || null);
            this.factureListDisplaySub = this.factureListDisplayService.settings$.subscribe((s) => {
                this.factureListDisplay = s;
                this.cdr.detectChanges();
            });
        }
    }

    loadUserData(): void {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.userId = Number(currentUser?.id) || 0;
        /** Toujours aligné sur `localStorage.currentUser` (stations[0].station_id → id → user.station_id). Ne pas remplacer par l’id renvoyé par GET /station. */
        this.stationId = getStationIdFromLocalStorage();
    }

    loadStationData(): void {
        this.loadUserData();
        if (!this.stationId) {
            return;
        }

        this.stationService.getStation(this.stationId).subscribe({
            next: (response) => {
                if (response && response.success && response.station) {
                    this.stationData = response.station;
                    if (this.stationData.coordonnees && Array.isArray(this.stationData.coordonnees) && this.stationData.coordonnees.length > 0) {
                        //console.log('📋 [SharedComponent] Première coordonnée:', this.stationData.coordonnees[0]);
                    } else {
                        console.log('📋 [SharedComponent] Structure complète de response.station:', JSON.stringify(response.station, null, 2));
                    }
                } else {
                    console.log('📋 [SharedComponent] Réponse complète:', JSON.stringify(response, null, 2));
                }
            },
            error: (error) => {
                console.error('❌ [SharedComponent] Détails de l\'erreur:', JSON.stringify(error, null, 2));
            }
        });
    }

    loadClients(): void {
        if (!this.stationId) {
            return;
        }
        this.isLoadingClients = true;
        this.clientService.getActiveClient(this.stationId, 1, 100).subscribe({
            next: (response) => {
                this.clients = response.data || [];
                this.isLoadingClients = false;
            },
            error: (error) => {
                this.clients = [];
                this.isLoadingClients = false;
            }
        });
    }

    loadFournisseurs(): void {
        if (!this.stationId) {
            return;
        }
        this.isLoadingFournisseurs = true;
        this.fournisseurService.getActiveFournisseur(this.stationId, 1, 100).subscribe({
            next: (response) => {
                this.fournisseurs = response.data || [];
                this.isLoadingFournisseurs = false;
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.fournisseurs = [];
                this.isLoadingFournisseurs = false;
                this.cdr.detectChanges();
            }
        });
    }

    loadEntrepots(): void {
        if (!this.stationId || !this.userId) {
            return;
        }
        this.isLoadingEntrepots = true;
        this.warehouseService.getAllWarehouses(this.userId, this.stationId).subscribe({
            next: (response: any) => {
                this.entrepots = Array.isArray(response) ? response : (response?.data || []);
                this.isLoadingEntrepots = false;
                this.cdr.detectChanges();
            },
            error: () => {
                this.entrepots = [];
                this.isLoadingEntrepots = false;
                this.cdr.detectChanges();
            }
        });
    }

    loadProjects(): void {
        if (!this.stationId) {
            return;
        }
        this.isLoadingProjects = true;
        this.projetService.getProjectsByIdStation(this.stationId).subscribe({
            next: (response: any) => {
                let rawProjects: any[] = [];
                if (Array.isArray(response)) {
                    rawProjects = response;
                } else if (response && response.projectsListe && Array.isArray(response.projectsListe)) {
                    rawProjects = response.projectsListe;
                } else if (response && response.data && Array.isArray(response.data)) {
                    rawProjects = response.data;
                }
                this.projects = rawProjects.filter((p: any) => p.statut === true || p.status === true);
                this.isLoadingProjects = false;
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.projects = [];
                this.isLoadingProjects = false;
                this.cdr.detectChanges();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['archiveData'] && !changes['archiveData'].firstChange) {
            this.updateFilteredData();
            this.calculateFactureTotals();
            this.cdr.detectChanges();
        }
        const stockType = this.type === 'inventaire' || this.type === 'bon-transfert';
        if (stockType && (changes['type'] || changes['status'])) {
            const typeCh = changes['type'];
            const statCh = changes['status'];
            const typeChanged = typeCh && !typeCh.firstChange && typeCh.previousValue !== typeCh.currentValue;
            const statusChanged = statCh && !statCh.firstChange && statCh.previousValue !== statCh.currentValue;
            if (typeChanged || statusChanged) {
                this.filterByStatus(this.status);
            }
        }
        if (changes['type'] && this.type === 'facture') {
            this.loadStatsFacturesGlobales();
        }
        if (changes['type'] && this.type === 'facture-fournisseur') {
            this.loadStatsFacturesFournisseurGlobales();
        }
        const fs = changes['fournisseurScopeId'];
        if (fs && !fs.firstChange && this.type) {
            const achatFournisseurTypes = ['commande-fournisseur', 'bon-reception', 'facture-fournisseur', 'retour-fournisseur'];
            const fid = this.parseFournisseurScopeId();
            if (fid != null && achatFournisseurTypes.includes(this.type)) {
                this.isLoading = true;
                this.cdr.detectChanges();
                this.achatService.setSupplierDocumentScope(this.type, true);
                this.achatService.loadByTypeAndStatusForFournisseur(fid, this.type, this.normalizeStatus(this.status));
            }
        }
    }

    ngOnDestroy() {
        const achatFournisseurTypes = ['commande-fournisseur', 'bon-reception', 'facture-fournisseur', 'retour-fournisseur'];
        if (
            this.type &&
            achatFournisseurTypes.includes(this.type) &&
            this.fournisseurScopeId != null &&
            this.fournisseurScopeId !== ''
        ) {
            this.achatService.setSupplierDocumentScope(this.type, false);
        }
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
        if (this.pdfExportSubscription) {
            this.pdfExportSubscription.unsubscribe();
        }
        if (this.clientDetailsScopeResolveSub) {
            this.clientDetailsScopeResolveSub.unsubscribe();
        }
        if (this.erpFactureLinksSub) {
            this.erpFactureLinksSub.unsubscribe();
        }
        if (this.factureListDisplaySub) {
            this.factureListDisplaySub.unsubscribe();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            Feather.replace();
            this.cdr.detectChanges();
            setTimeout(() => Feather.replace(), 100);
        }, 0);
        this.initializeFlatpickr();
        this.initializeFilterDatePickers();
        this.centerTodayItem();
    }

    centerTodayItem() {
        setTimeout(() => {
            if (this.viewMode === 'jours') {
                const todayElement = document.querySelector('.day-item.today');
                if (todayElement) {
                    todayElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                }
            } else if (this.viewMode === 'mois') {
                const todayElement = document.querySelector('.month-item.today');
                if (todayElement) {
                    todayElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                }
            } else if (this.viewMode === 'annees') {
                const todayElement = document.querySelector('.year-item.today');
                if (todayElement) {
                    todayElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                }
            }
        }, 100);
    }

    private parseDate(dateStr: string | Date): Date | null {
        if (!dateStr) return null;
        if (dateStr instanceof Date) {
            return isNaN(dateStr.getTime()) ? null : dateStr;
        }
        const dateString = String(dateStr).trim();
        if (!dateString) return null;
        const match1 = dateString.match(/(\d{1,2})\s*\/\s*(\d{1,2})\s*\/\s*(\d{4})/);
        if (match1) {
            const day = parseInt(match1[1], 10);
            const month = parseInt(match1[2], 10) - 1;
            const year = parseInt(match1[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            const year = parseInt(isoMatch[1], 10);
            const month = parseInt(isoMatch[2], 10) - 1;
            const day = parseInt(isoMatch[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        const parsed = new Date(dateString);
        if (!isNaN(parsed.getTime())) {
            return parsed;
        }
        
        return null;
    }

    changeViewMode(mode: 'jours' | 'mois' | 'annees'): void {
        this.viewMode = mode;
        this.centerTodayItem();
        if (mode === 'jours') {
            const dayToUse = this.selectedDay || todayLocalDateKey();
            if (this.dateFilterStart !== dayToUse || this.dateFilterEnd !== dayToUse) {
                this.dateFilterStart = dayToUse;
                this.dateFilterEnd = dayToUse;
                this.selectedDay = dayToUse;
                this.selectedDate = this.parseDate(dayToUse) || new Date();
                this.applyDateFilter(dayToUse, dayToUse);
            } else {
                this.selectedDate = this.parseDate(dayToUse) || new Date();
            }
            // Toujours rafraîchir le libellé (ex. retour Mois → Jours : éviter de garder « Mois: … » à côté des flèches).
            this.updateSelectedPeriod();
        } else if (mode === 'mois') {
            const monthIndex = this.selectedMonthIndex !== null ? this.selectedMonthIndex : this.currentMonthIndex;
            const year = this.selectedYear !== null ? this.selectedYear : this.currentYear;
            this.selectedMonthIndex = monthIndex;
            this.selectedYear = year;
            const monthStart = formatLocalDateKey(new Date(year, monthIndex, 1));
            const monthEnd = formatLocalDateKey(new Date(year, monthIndex + 1, 0));
            this.dateFilterStart = monthStart;
            this.dateFilterEnd = monthEnd;
            this.selectedPeriod = `Mois: ${this.months[monthIndex]} ${year}`;
            this.selectedDate = new Date(year, monthIndex, 1);
            this.selectedDay = '';
            if (this.datePicker?.nativeElement?._flatpickr) {
                this.datePicker.nativeElement._flatpickr.setDate([monthStart, monthEnd], false);
            }
            
            this.applyDateFilter(monthStart, monthEnd);
        } else if (mode === 'annees') {
            const year = this.selectedYear !== null ? this.selectedYear : this.currentYear;
            this.selectedYear = year;
            this.selectedMonthIndex = null;
            this.selectedDay = '';
            const yearStart = `${year}-01-01`;
            const yearEnd = `${year}-12-31`;
            this.dateFilterStart = yearStart;
            this.dateFilterEnd = yearEnd;
            this.selectedPeriod = `Année: ${year}`;
            this.selectedDate = new Date(year, 0, 1);
            if (this.datePicker?.nativeElement?._flatpickr) {
                this.datePicker.nativeElement._flatpickr.setDate([yearStart, yearEnd], false);
            }
            this.applyDateFilter(yearStart, yearEnd);
        }
    }

    removeBlur() {
        this.isBlurRemoved = true;
        this.cdr.detectChanges();
    }

    private calculateFactureTotals() {
        if (this.isBlurRemoved) {
            const factures = this.archiveData as (Facture | CommandeFournisseur)[];

            this.totalFactureTTC = factures.reduce((sum, f) => {
                const revenue = parseFloat((f.revenue || '0').replace(',', '.').replace(' TND', '')) || 0;
                return sum + revenue;
            }, 0);

            this.totalFactureHTC = this.totalFactureTTC * 0.8;

            this.totalFacturePaye = factures
                .filter(f => f.status === 'Payée' || f.status === 'Payé')
                .reduce((sum, f) => sum + (parseFloat((f.revenue || '0').replace(',', '.').replace(' TND', '')) || 0), 0);

            this.totalFactureAPaye = factures
                .filter(f => f.status === 'Non payé')
                .reduce((sum, f) => sum + (parseFloat((f.revenue || '0').replace(',', '.').replace(' TND', '')) || 0), 0);

            this.totalFactureRetard = factures
                .filter(f => {
                    if (f.status !== 'Non payé') return false;
                    const factureDate = this.parseDate(f.date);
                    if (!factureDate) return false;
                    return factureDate < new Date();
                })
                .reduce((sum, f) => sum + (parseFloat((f.revenue || '0').replace(',', '.').replace(' TND', '')) || 0), 0);
        } else {
            this.totalFactureTTC = this.totalFactureHTC = this.totalFacturePaye = this.totalFactureAPaye = this.totalFactureRetard = 0;
        }
    }

    filterByStatus(status: string) {
        this.isLoading = true;
        this.cdr.detectChanges();
        const normalizedStatus = this.normalizeStatus(status);
        this.status = normalizedStatus;
        if (this.type === 'inventaire' || this.type === 'bon-transfert') {
            this.loadStockDocuments();
            return;
        }

        const fid = this.parseFournisseurScopeId();
        const achatFournisseurTypes = ['commande-fournisseur', 'bon-reception', 'facture-fournisseur', 'retour-fournisseur'];
        if (fid != null && this.type && achatFournisseurTypes.includes(this.type)) {
            this.achatService.setSupplierDocumentScope(this.type, true);
            this.achatService.loadByTypeAndStatusForFournisseur(fid, this.type, normalizedStatus);
            return;
        }

        const filterMethod = this.getStatusFilterMethod();
        const service = this.getService();
        this.reloadDocumentsForCurrentList(normalizedStatus, service);
    }

    /** Plage calendrier envoyée à l’API (`date_from` / `date_to`). */
    private resolveApiDateRange(): { from?: string; to?: string } {
        if (this.type === 'avoir' || this.type === 'avoir-fournisseur') {
            return {};
        }
        const from = (this.filters.date_du || this.dateFilterStart || '').trim();
        const to = (this.filters.date_jusqua || this.dateFilterEnd || from).trim();
        if (!from && !to) {
            return {};
        }
        return { from: from || to, to: to || from };
    }

    private reloadDocumentsForCurrentList(normalizedStatus: string, service = this.getService()): void {
        const { from, to } = this.resolveApiDateRange();
        if (service === this.dataService) {
            this.dataService.loadByTypeAndStatus(this.type || 'devis', normalizedStatus, from, to);
            return;
        }
        if (typeof (service as any).setDateRangeFilter === 'function') {
            (service as any).setDateRangeFilter(from, to);
        }
        const filterMethod = this.getStatusFilterMethod();
        filterMethod.call(service, normalizedStatus, from, to);
    }

    private parseFournisseurScopeId(): number | null {
        if (this.fournisseurScopeId == null || this.fournisseurScopeId === '') {
            return null;
        }
        const n = Number(this.fournisseurScopeId);
        return !Number.isNaN(n) && n > 0 ? n : null;
    }

    /** Recharge les données achat (liste globale ou filtre fournisseur selon le contexte). */
    private reloadAchatDataByCurrentScope(normalizedStatus: string): void {
        const fid = this.parseFournisseurScopeId();
        const achatFournisseurTypes = ['commande-fournisseur', 'bon-reception', 'facture-fournisseur', 'retour-fournisseur'];
        if (fid != null && this.type && achatFournisseurTypes.includes(this.type)) {
            this.achatService.setSupplierDocumentScope(this.type, true);
            this.achatService.loadByTypeAndStatusForFournisseur(fid, this.type, normalizedStatus);
        } else {
            const filterMethod = this.getStatusFilterMethod();
            const service = this.getService();
            this.reloadDocumentsForCurrentList(normalizedStatus, service);
        }
    }

    private getService() {
        return ['commande-fournisseur', 'bon-reception', 'facture-fournisseur', 'retour-fournisseur', 'avoir-fournisseur'].includes(this.type!)
            ? this.achatService
            : this.dataService;
    }

    private getDataObservable() {
        switch (this.type) {
            case 'devis':
                return this.dataService.quoteTableData$;
            case 'commande-client':
                return this.dataService.orderTableData$;
            case 'facture':
                return this.dataService.factureTableData$.pipe(
                    map((data: any[]) => (data || []).filter((d: any) => this.isFactureDocument(d)))
                );
            case 'avoir':
                return this.dataService.avoirTableData$;
            case 'bon-livraison':
                return this.dataService.bonLivraisonTableData$;
            case 'bon-sortie':
                return this.dataService.bonSortieTableData$;
            case 'commande-fournisseur':
                return this.achatService.commandeFournisseurTableData$;
            case 'bon-reception':
                return this.achatService.bonReceptionTableData$;
            case 'facture-fournisseur':
                return this.achatService.factureFournisseurTableData$.pipe(
                    map((data: any[]) => (data || []).filter((d: any) => this.isFactureDocument(d)))
                );
            case 'retour-fournisseur':
                return this.achatService.retourFournisseurTableData$.pipe(
                    map((data: any[]) => (data || []).filter((d: any) => this.isFactureDocument(d)))
                );
            case 'avoir-fournisseur':
                return this.achatService.avoirFournisseurTableData$;
            case 'inventaire':
            case 'bon-transfert':
                return of([]);
            default:
                return this.router.url.includes('/achat') ? this.achatService.commandeFournisseurTableData$ : this.dataService.quoteTableData$;
        }
    }

    private applyTypeFilterForArchive(data: any[]): any[] {
        if (!data || !Array.isArray(data)) return [];
        switch (this.type) {
            case 'facture':
            case 'facture-fournisseur':
            case 'retour-fournisseur':
                return data.filter((d: any) => this.isFactureDocument(d));
            case 'avoir':
            case 'avoir-fournisseur':
                return data;
            default:
                return data;
        }
    }


    private isAvoirDocument(d: any): boolean {
        return isAvoirTableRow(d);
    }

    private readonly factureStatuses = ['Brouillon', 'Payé', 'Payée', 'Non payé', 'Partiellement payé', 'Annulé', 'Annulée'];


    private isFactureDocument(d: any): boolean {
        return isFactureTableRowExcludingAvoirs(d, this.factureStatuses);
    }

    private isPayeStatus(d: any): boolean {
        const raw = d?.fullData ?? d;
        const status = (raw?.statut?.titre ?? d?.status ?? raw?.status ?? '').toString().trim();
        return status === 'Payé' || status === 'Payée';
    }

    getDisplayStatus(item: any): string {
        const raw = (item?.status ?? item?.fullData?.statut?.titre ?? '').toString().trim();
        const sid = Number(item?.fullData?.statut_id ?? item?.statut_id ?? item?.fullData?.statut?.id);
        const byId: Record<number, string> = {
            1: 'Brouillon',
            3: 'Accepté',
            5: 'Payé',
            6: 'Annulé',
            8: 'Négociation',
            9: 'Crée',
            10: 'Valide',
            11: 'Livré',
            12: 'Non payé',
            13: 'Fermé',
            14: 'Reçu',
            15: 'Partiellement payé',
            16: 'En cours',
            17: 'Transféré',
            18: 'Utilisé',
            19: 'Non utilisé',
            20: 'Partiellement utilisé',
        };
        let status = Number.isFinite(sid) && byId[sid] ? byId[sid] : this.repairStatusEncoding(raw);
        status = this.normalizeStatus(status) || status;

        if (this.type !== 'avoir' && this.type !== 'avoir-fournisseur') {
            return status || '—';
        }
        const s = status;
        const avoirLabels: Record<string, string> = {
            Brouillon: 'Brouillon',
            'Non utilisé': 'Non utilisé',
            'Partiellement utilisé': 'Partiellement utilisé',
            Utilisé: 'Utilisé',
            Annulé: 'Annulé',
            Annulée: 'Annulé',
            Crée: 'Brouillon',
            Créé: 'Brouillon'
        };
        if (avoirLabels[s]) {
            return avoirLabels[s];
        }
        const sl = s.toLowerCase();
        if (sl.includes('non') && sl.includes('utilisé')) {
            return 'Non utilisé';
        }
        if (sl.includes('partiellement')) {
            return 'Partiellement utilisé';
        }
        if (sl.includes('utilisé') && !sl.includes('non') && !sl.includes('partiellement')) {
            return 'Utilisé';
        }
        return s || status || '—';
    }

    /** Répare « Non pay├® » → « Non payé » (UTF-8 mal décodé). */
    private repairStatusEncoding(status: string): string {
        const raw = String(status || '').trim();
        if (!raw || !/[├ÂÃ]/.test(raw)) {
            return raw;
        }
        try {
            const bytes = new Uint8Array(raw.length);
            for (let i = 0; i < raw.length; i++) {
                bytes[i] = raw.charCodeAt(i) & 0xff;
            }
            const decoded = new TextDecoder('utf-8').decode(bytes);
            if (decoded && !decoded.includes('\uFFFD')) {
                return decoded.trim();
            }
        } catch {
            /* ignore */
        }
        return raw.replace(/pay├®/gi, 'payé').replace(/├®/g, 'é').replace(/Ã©/g, 'é');
    }

    /** Classe CSS badge Vuexy (badge-light-*) selon le statut. */
    getItemStatusBadgeClass(item: any): Record<string, boolean> {
        const display = this.getDisplayStatus(item);
        const n = (this.normalizeStatus(display) || display).toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const isAvoir = this.type === 'avoir' || this.type === 'avoir-fournisseur';

        const isBrouillon = n === 'brouillon' || (isAvoir && n === 'cree');
        const isCree = !isAvoir && n === 'cree';
        const isPaye = n === 'paye' || n === 'payee';
        const isNonPaye = n.includes('non') && n.includes('paye') && !n.includes('partiel');
        const isPartPaye = n.includes('partiellement') && n.includes('paye');
        const isAnnule = n === 'annule' || n === 'annulee';
        const isNonUtilise = n.includes('non') && n.includes('utilise');
        const isPartUtilise = n.includes('partiellement') && n.includes('utilise');
        const isUtilise = n === 'utilise';
        const isSuccess =
            isPaye ||
            isUtilise ||
            n === 'accepte' ||
            n === 'valide' ||
            n === 'livre' ||
            n === 'recu' ||
            n === 'transfere';
        const isWarning =
            isPartPaye ||
            isPartUtilise ||
            n === 'negociation' ||
            n === 'en cours' ||
            n === 'encours';
        const isDanger = isNonPaye || isAnnule;
        const isInfo = isCree || isNonUtilise;
        const isSecondary = isBrouillon || n === 'ferme';

        return {
            'badge-light-secondary': isSecondary,
            'badge-light-info': isInfo,
            'badge-light-success': isSuccess && !isDanger,
            'badge-light-warning': isWarning,
            'badge-light-danger': isDanger,
            // aliases historiques (listes / filtres)
            'badge-brouillon': isBrouillon,
            'badge-cree': isCree,
            'badge-annule': isAnnule,
            'badge-accepte': n === 'accepte',
            'badge-paye': isPaye,
            'badge-nonPaye': isNonPaye,
            'badge-negociation': n === 'negociation',
            'badge-ferme': n === 'ferme',
            'badge-recu': n === 'recu',
            'badge-livré': n === 'livre',
            'badge-valide': n === 'valide',
            'badge-partiellement-payé': isPartPaye,
            'badge-transfere': n === 'transfere',
            'badge-enCours': n === 'en cours' || n === 'encours',
            'badge-non-utilise': isNonUtilise,
            'badge-partiellement-utilise': isPartUtilise,
            'badge-utilise': isUtilise && !isNonUtilise && !isPartUtilise,
        };
    }

    /** Statuts possibles selon le statut actuel du document (workflow), pour le popover au survol du badge. */
    getStatusesForPopover(item: any): string[] {
        const currentStatus = (item?.status ?? item?.fullData?.statut?.titre ?? '').toString().trim();
        if (!currentStatus) return [];
        const normalized = this.normalizeStatus(currentStatus) || currentStatus;
        const keyFrom = (s: string) => s.toLowerCase().replace(/\s+/g, '_');
        const byType = this.STATUS_WORKFLOW[this.type || ''];
        if (!byType) return [];
        const list = byType[keyFrom(normalized)] ?? byType[keyFrom(currentStatus)] ?? byType[normalized] ?? byType[currentStatus];
        return Array.isArray(list) ? list : [];
    }

    /** Workflow : pour chaque type, statut actuel -> liste des statuts possibles (suivants). */
    private readonly STATUS_WORKFLOW: Record<string, Record<string, string[]>> = {
        'devis': {
            'brouillon': ['Crée', 'Annulé'],
            'créé': ['Négociation', 'Accepté', 'Annulé'],
            'crée': ['Négociation', 'Accepté', 'Annulé'],
            'négociation': ['Accepté', 'Annulé'],
            'accepté': [],
            'annulé': []
        },
        'commande-client': {
            'brouillon': ['Valide', 'Crée', 'Annulé'],
            'valide': ['Crée', 'Annulé'],
            'créé': ['Annulé', 'Valide'],
            'crée': ['Annulé', 'Valide'],
            'annulé': []
        },
        'facture': {
            'brouillon': ['Payé', 'Non payé', 'Annulée'],
            'payé': [],
            'payée': [],
            'non_payé': ['Payé', 'Partiellement payé', 'Annulée'],
            'partiellement_payé': ['Payé', 'Annulée'],
            'annulée': []
        },
        'avoir': {
            'brouillon': ['Non utilisé', 'Partiellement utilisé', 'Utilisé', 'Annulé'],
            'non_utilisé': ['Partiellement utilisé', 'Utilisé', 'Annulé'],
            'partiellement_utilisé': ['Utilisé', 'Annulé'],
            'utilisé': [],
            'annulé': []
        },
        'bon-livraison': {
            'brouillon': ['Crée', 'Annulé'],
            'créé': ['Livré', 'Annulé'],
            'crée': ['Livré', 'Annulé'],
            'livré': [],
            'annulé': []
        },
        'bon-sortie': {
            'brouillon': ['Crée', 'Annulé'],
            'créé': ['Fermé', 'Annulé'],
            'crée': ['Fermé', 'Annulé'],
            'fermé': [],
            'ferme': [],
            'annulé': []
        },
        'commande-fournisseur': {
            'brouillon': ['Valide', 'Crée', 'Annulé'],
            'valide': ['Crée', 'Annulé'],
            'créé': ['Annulé'],
            'crée': ['Annulé'],
            'annulé': []
        },
        'bon-reception': {
            'brouillon': ['Crée', 'Annulé'],
            'créé': ['Reçu', 'Annulé'],
            'crée': ['Reçu', 'Annulé'],
            'reçu': [],
            'annulé': []
        },
        'facture-fournisseur': {
            'brouillon': ['Payé', 'Non payé', 'Annulé'],
            'payé': [],
            'payée': [],
            'non_payé': ['Payé', 'Partiellement payé', 'Annulé'],
            'partiellement_payé': ['Payé', 'Annulé'],
            'annulé': []
        },
        'retour-fournisseur': {
            'brouillon': ['Payé', 'Non payé', 'Annulé'],
            'payé': [],
            'payée': [],
            'non_payé': ['Payé', 'Partiellement payé', 'Annulé'],
            'partiellement_payé': ['Payé', 'Annulé'],
            'annulé': []
        },
        'avoir-fournisseur': {
            'brouillon': ['Non utilisé', 'Partiellement utilisé', 'Utilisé', 'Annulé'],
            'non_utilisé': ['Partiellement utilisé', 'Utilisé', 'Annulé'],
            'partiellement_utilisé': ['Utilisé', 'Annulé'],
            'utilisé': [],
            'annulé': []
        },
        'inventaire': {
            'brouillon': ['Crée', 'Annulé'],
            'créé': ['Annulé'],
            'crée': ['Annulé'],
            'annulé': []
        },
        'bon-transfert': {
            'brouillon': ['Crée', 'Annulé'],
            'créé': ['Annulé'],
            'crée': ['Annulé'],
            'annulé': []
        }
    };

    private deduplicateDocumentsById(docs: any[]): any[] {
        if (!docs || !Array.isArray(docs)) return [];
        const seen = new Set<string | number>();
        return docs.filter((doc: any) => {
            const id = doc?.id ?? doc?.fullData?.id;
            const ref = doc?.reference ?? doc?.ref_externe ?? doc?.fullData?.reference ?? doc?.fullData?.ref_externe;
            const key = id != null ? id : (ref != null ? String(ref) : null);
            if (key == null) return true;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }

    private loadStockDocuments(): void {
        this.loadUserData();
        if (!this.stationId) {
            this.isLoading = false;
            this.archiveData = [];
            this.updateFilteredData();
            this.cdr.detectChanges();
            return;
        }

        this.isLoading = true;
        this.cdr.detectChanges();

        const typeDocumentId = this.getTypeDocumentId(this.type);
        const normalizedStatus = this.normalizeStatus(this.status);

        // Toujours charger par station (+ user_id) : getByStatutAndType ne filtre pas par station et
        // peut renvoyer une liste vide ou hors périmètre. Le statut est appliqué ensuite côté client.
        const apiCall = this.documentService.getByStationAndType(
            this.stationId,
            typeDocumentId,
            1,
            200,
            this.userId
        );

        apiCall.subscribe({
            next: (response) => {

                const documents = this.documentService.getDocumentsArrayFromApiResponse(response);
                let filteredDocs = documents;
                if (normalizedStatus !== 'Tous' && normalizedStatus !== 'tous') {
                    const statutId = this.getStatutId(normalizedStatus);
                    if (statutId) {
                        filteredDocs = documents.filter((doc: any) => {
                            const docStatutId = doc.statut_id || doc.statut?.id;
                            return docStatutId === statutId;
                        });
                    } else {
                        filteredDocs = documents.filter((doc: any) => {
                            const docStatut = doc.statut?.titre || doc.statutDocument?.titre || '';
                            return this.normalizeStatus(docStatut) === normalizedStatus;
                        });
                    }
                }
                // Les dates sont filtrées dans updateFilteredData() (comme devis / facture / …), pas ici.
                const normalizedData = filteredDocs.map((doc: any) => this.normalizeStockDocument(doc));
                this.archiveData = this.deduplicateDocumentsById(normalizedData);
                this.isLoading = false;
                this.updateFilteredData();
                this.calculateFactureTotals();
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.hasDataLoaded = true;
                this.isLoading = false;
                this.archiveData = [];
                this.updateFilteredData();
                this.toastr.error('Erreur lors du chargement des documents', 'Erreur');
                this.cdr.detectChanges();
            }
        });
    }

    /** Libellé type document (Avoir / Avoir fournisseur) pour le tableau. */
    getDocumentTypeLabel(item: any): string {
        if (this.type !== 'avoir' && this.type !== 'avoir-fournisseur') {
            return '';
        }
        const fromRow = (item as any)?.typeDocumentLabel;
        if (fromRow && String(fromRow).trim()) {
            return String(fromRow).trim();
        }
        const doc = item?.fullData ?? item;
        const t = doc?.typeDocument?.titre || doc?.type_document?.titre;
        if (t && String(t).trim()) {
            return String(t).trim();
        }
        return this.type === 'avoir-fournisseur' ? 'Avoir fournisseur' : 'Avoir';
    }

    /** Nombre de colonnes du tableau (lignes vides / chargement). */
    getTableColspan(): number {
        if (this.type === 'bon-transfert') {
            return 6;
        }
        if (this.type === 'avoir' || this.type === 'avoir-fournisseur') {
            return 7;
        }
        if (this.type === 'facture') {
            let n = 1; // ACTION
            if (this.isFactureListColumnVisible('reference')) n++;
            if (this.isFactureListColumnVisible('date')) n++;
            if (this.isFactureListColumnVisible('client')) n++;
            if (this.isFactureListColumnVisible('codeClient')) n++;
            if (this.isFactureListColumnVisible('matricule')) n++;
            if (this.isFactureListColumnVisible('nif')) n++;
            if (this.isFactureListColumnVisible('email')) n++;
            if (this.isFactureListColumnVisible('codeEtablissement')) n++;
            if (this.isFactureListColumnVisible('codeEntrepot')) n++;
            if (this.isFactureListColumnVisible('ht')) n++;
            if (this.isFactureListColumnVisible('tva')) n++;
            if (this.isFactureListColumnVisible('ttc')) n++;
            if (this.isFactureListColumnVisible('timbreFiscal')) n++;
            if (this.isFactureListColumnVisible('netPayer')) n++;
            if (this.isFactureListColumnVisible('dateLivraison')) n++;
            if (this.isFactureListColumnVisible('note')) n++;
            if (this.isFactureListColumnVisible('createdAt')) n++;
            if (this.isFactureListColumnVisible('statut')) n++;
            return Math.max(n, 2);
        }
        return 6;
    }

    /** Visibilité colonne liste facture (autres types : toujours visible). */
    isFactureListColumnVisible(column: keyof FactureListDisplaySettings): boolean {
        if (this.type !== 'facture') {
            return true;
        }
        const s = this.factureListDisplay || this.factureListDisplayService.settings;
        return s[column] !== false;
    }

    getFactureDateLivraison(item: any): string {
        const raw =
            item?.fullData?.date_livraison ??
            item?.date_livraison ??
            item?.fullData?.dateLivraison ??
            null;
        if (!raw) {
            return '—';
        }
        const d = new Date(raw);
        if (Number.isNaN(d.getTime())) {
            return String(raw);
        }
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${dd} / ${mm} / ${yyyy}`;
    }

    getFactureCreatedAt(item: any): string {
        const raw = item?.createdAt ?? item?.fullData?.created_at ?? item?.fullData?.createdAt ?? null;
        if (!raw) {
            return '—';
        }
        const d = new Date(raw);
        if (Number.isNaN(d.getTime())) {
            return String(raw);
        }
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${dd} / ${mm} / ${yyyy}`;
    }

    getFactureEmail(item: any): string {
        const email = item?.email ?? item?.fullData?.clients?.[0]?.email ?? item?.fullData?.client_data?.email;
        const s = String(email || '').trim();
        return s || '—';
    }

    getFactureCodeClient(item: any): string {
        const code =
            item?.codeClient ??
            item?.fullData?.clients?.[0]?.code_client ??
            item?.fullData?.client_data?.code_client ??
            item?.fullData?.clients?.[0]?.identifiant_unique ??
            item?.fullData?.client_data?.identifiant_unique ??
            null;
        const s = String(code || '').trim();
        return s || '—';
    }

    getFactureNif(item: any): string {
        const nif =
            item?.nif ??
            item?.fullData?.clients?.[0]?.numero_identification_fiscale ??
            item?.fullData?.client_data?.numero_identification_fiscale ??
            null;
        const s = String(nif || '').trim();
        return s || '—';
    }

    getFactureCodeEtablissement(item: any): string {
        const code =
            item?.codeEtablissement ??
            item?.fullData?.code_etablissement ??
            item?.fullData?.etablissement?.code_etablissement ??
            item?.fullData?.etablissement?.code ??
            null;
        const s = String(code || '').trim();
        if (s) {
            return s;
        }
        const id = Number(item?.fullData?.etablissement?.id);
        if (Number.isFinite(id) && id > 0) {
            return String(id).padStart(5, '0');
        }
        return '—';
    }

    getFactureCodeEntrepot(item: any): string {
        const code =
            item?.codeEntrepot ??
            item?.fullData?.code_entrepot ??
            item?.fullData?.entrepot?.code_entrepot ??
            item?.fullData?.entrepot?.code ??
            null;
        const s = String(code || '').trim();
        return s || '—';
    }

    getFactureNote(item: any): string {
        const note = item?.note ?? item?.fullData?.note;
        const s = String(note || '').trim();
        return s || '—';
    }

    private getStatutId(statutName: string): number | null {
        const statutMap: { [key: string]: number } = {
            'Brouillon': 1,
            'Crée': 9,
            'Créé': 9,
            'Annulé': 6,
            'Valide': 10,
            'Inventorié': 15,
            'Transféré': 17
        };
        return statutMap[statutName] || null;
    }
    private normalizeStockDocument(doc: any): any {
        const statutTitre = doc.statut?.titre || doc.statutDocument?.titre || 'Crée';
        const dateDoc = doc.date || doc.date_document || todayLocalDateKey();
        let clientName = '--';
        if (this.type === 'inventaire') {
            const client = doc.clients?.[0] || doc.client_data || doc.client;
            clientName = this.resolveVenteClientLabel(client) || '--';
        }
        
        return {
            id: doc.id || doc.document_id,
            reference: doc.ref_externe || doc.reference || `DOC-${doc.id || '000000'}`,
            date: dateDoc,
            status: statutTitre,
            revenue: this.calculateDocumentTotal(doc),
            clientName: clientName,
            fullData: doc
        };
    }

    private calculateDocumentTotal(doc: any): string {
        const lignes = doc.lignes_document || doc.lignesDocument || [];
        if (!lignes || lignes.length === 0) {
            return '0.000 TND';
        }
        
        const total = lignes.reduce((sum: number, ligne: any) => {
            const prix = parseFloat(ligne.prix_ht) || 0;
            const qnt = parseFloat(ligne.qnt) || 0;
            const tva = parseFloat(ligne.tva) || 0;
            const totalHT = prix * qnt;
            const totalTTC = totalHT * (1 + tva / 100);
            return sum + totalTTC;
        }, 0);
        
        return `${total.toFixed(3)} TND`;
    }
    private getTypeDocumentId(type: string | undefined): number {
        const typeMap: { [key: string]: number } = {
            'devis': 7,
            'commande-client': 8,
            'bon-sortie': 9,
            'bon-livraison': 10,
            'facture': 11,
            'commande-fournisseur': 12,
            'bon-reception': 13,
            'facture-fournisseur': 14,
            'retour-fournisseur': 17,
            'inventaire': 15,
            'bon-transfert': 16
        };
        return typeMap[type || 'devis'] || 7;
    }

    updateFilteredData() {
        const normalizedStatus = this.normalizeStatus(this.status);
        const isAchat = this.baseRoute === '/achat';
        const isStockDocument = this.type === 'inventaire' || this.type === 'bon-transfert';
        
        if (!this.archiveData || this.archiveData.length === 0) {

            this.filteredData = [];
            if (!this.isLoading) {
                this.updatePagination();
            }
            this.cdr.detectChanges();
            return;
        }
        if (this.filters.client_id && !isAchat && !isStockDocument) {
            const allClientIds = this.archiveData.map((item: any, idx: number) => {
                const itemAny = item as any;
                const doc = itemAny.fullData || item;
                const clientId = doc.clients?.[0]?.client_id ||
                               doc.clients?.[0]?.pivot?.client_id ||
                               doc.client_id ||
                               doc.client_data?.client_id ||
                               doc.client_data?.id ||
                               doc.clients?.[0]?.id ||
                               itemAny.client_id;
                return {
                    index: idx,
                    reference: item.reference,
                    clientId: clientId,
                    docClients: doc.clients,
                    docClientData: doc.client_data
                };
            });

        }
        
        this.filteredData = this.archiveData.filter((item, index) => {
            const itemAny = item as any;
            const doc = itemAny.fullData || item;
            const itemData = itemAny;
            const matchesSearch =
                this.searchTerm === '' ||
                (item.reference?.toLowerCase().includes(this.searchTerm.toLowerCase()) || false) ||
                (item.clientName?.toLowerCase().includes(this.searchTerm.toLowerCase()) || false) ||
                this.matchesClientEntrepriseSearch(item, this.searchTerm);
            const matchesRaison = this.filters.raison === '' ||
                (item.clientName?.toLowerCase().includes(this.filters.raison.toLowerCase()) || false) ||
                this.matchesClientEntrepriseSearch(item, this.filters.raison);
            const matchesMatricule = this.filters.matricule === '' ||
                (item.matricule?.toLowerCase().includes(this.filters.matricule.toLowerCase()) || false);
            const matchesChiffreAff = this.filters.chiffre_aff === '' ||
                (() => {
                    const revenue = parseFloat((item.revenue || '0').replace(',', '.').replace(' TND', '') || '0');
                    const filterValue = parseFloat(this.filters.chiffre_aff);
                    if (!filterValue && filterValue !== 0) return true;
                    if (this.filters.operator === '=') {
                        return Math.abs(revenue - filterValue) < 0.01;
                    }
                    if (this.filters.operator === '>') {
                        return revenue > filterValue;
                    }
                    if (this.filters.operator === '<') {
                        return revenue < filterValue;
                    }
                    return true;
                })();
            const matchesClient = (() => {
                if (isStockDocument) return true;
                if (isAchat) return true;
                const scopeId = this.clientDetailsScopeClientId;
                const filterRaw = this.filters.client_id;
                let requiredId: number | null = null;
                if (scopeId != null && !Number.isNaN(Number(scopeId))) {
                    requiredId = scopeId;
                } else if (filterRaw !== null && filterRaw !== undefined && filterRaw !== '') {
                    const parsed = parseInt(String(filterRaw), 10);
                    requiredId = Number.isNaN(parsed) ? null : parsed;
                }
                if (requiredId == null) {
                    return true;
                }
                const clientId = doc.clients?.[0]?.client_id ||
                    doc.clients?.[0]?.pivot?.client_id ||
                    doc.client_id ||
                    doc.client_data?.client_id ||
                    doc.client_data?.id ||
                    doc.clients?.[0]?.id ||
                    (item as any).client_id;
                if (clientId === undefined || clientId === null) {
                    return false;
                }
                const docClientId = parseInt(String(clientId), 10);
                return !Number.isNaN(docClientId) && docClientId === requiredId;
            })();
            const matchesEntrepot = (() => {
                if (this.type !== 'inventaire') return true;
                const filterRaw = this.filters.entrepot_id;
                if (filterRaw === null || filterRaw === undefined || filterRaw === '') {
                    return true;
                }
                const requiredId = parseInt(String(filterRaw), 10);
                if (Number.isNaN(requiredId)) return true;
                const entrepotIdRaw = doc.entrepot_id ?? doc.entrepot?.id ?? (item as any).entrepot_id;
                if (entrepotIdRaw === null || entrepotIdRaw === undefined) return false;
                const docEntrepotId = parseInt(String(entrepotIdRaw), 10);
                return !Number.isNaN(docEntrepotId) && docEntrepotId === requiredId;
            })();
            const matchesFournisseur = !this.filters.fournisseur_id || this.filters.fournisseur_id === '' || this.filters.fournisseur_id === null || String(this.filters.fournisseur_id).trim() === '' ||
                (() => {
                    if (isStockDocument) return true;
                    const filterFournisseurId = parseInt(String(this.filters.fournisseur_id));
                    if (isNaN(filterFournisseurId)) return true;
                    const fournisseurId = doc.fornisseurs?.[0]?.id ||
                                        doc.fornisseurs?.[0]?.fournisseur_id ||
                                        doc.fournisseur_data?.id ||
                                        doc.fournisseur_data?.fournisseur_id ||
                                        doc.fournisseur_id ||
                                        (isAchat ? (doc.clients?.[0]?.id || doc.client_data?.id) : null) ||
                                        (item as any).fournisseur_id;
                    
                    if (!fournisseurId && fournisseurId !== 0) {
                        return false;
                    }
                    const docFournisseurId = parseInt(String(fournisseurId));
                    return docFournisseurId === filterFournisseurId;
                })();
            const matchesProjet = !this.filters.projet_id || this.filters.projet_id === '' || this.filters.projet_id === null || this.filters.projet_id === undefined ||
                (() => {
                    let filterProjetId: number;
                    
                    if (typeof this.filters.projet_id === 'number') {
                        filterProjetId = this.filters.projet_id;
                    } else {
                        const filterProjetIdStr = String(this.filters.projet_id).trim();
                        if (!filterProjetIdStr || filterProjetIdStr === '') return true;
                        
                        filterProjetId = parseInt(filterProjetIdStr, 10);
                        if (isNaN(filterProjetId)) {
                            return true;
                        }
                    }
                    const projetIdRaw = doc.projets?.[0]?.id_projet ||
                                       doc.projets?.[0]?.id ||
                                       doc.projets?.[0]?.projet_id ||
                                       doc.projet_id ||
                                       doc.projets?.[0]?.pivot?.projet_id ||
                                       (item as any).projet_id;
                    const projetId = projetIdRaw !== null && projetIdRaw !== undefined 
                        ? (typeof projetIdRaw === 'string' ? parseInt(projetIdRaw, 10) : projetIdRaw)
                        : null;

                    if (projetId === null || projetId === undefined || isNaN(projetId)) {
                        return false;
                    }

                    const match = projetId === filterProjetId;
                    
                    if (index < 3 && this.filters.projet_id) {
                        console.log(`🔍 [matchesProjet] Comparaison: ${projetId} === ${filterProjetId} = ${match}`);
                    }
                    
                    return match;
                })();
            const matchesDate = (() => {
                // Avoir / avoir fournisseur : ne pas utiliser le calendrier principal (dateFilterStart/End),
                // souvent initialisé sur « aujourd'hui », ce qui vide la liste. Filtrer par date uniquement
                // via le panneau filtres (date_du / date_jusqua).
                const isAvoirList = this.type === 'avoir' || this.type === 'avoir-fournisseur';
                const dateDu = isAvoirList
                    ? (this.filters.date_du || '')
                    : (this.filters.date_du || this.dateFilterStart);
                const dateJusqua = isAvoirList
                    ? (this.filters.date_jusqua || '')
                    : (this.filters.date_jusqua || this.dateFilterEnd);

                if (!dateDu && !dateJusqua) return true;
                const docDate = item.date || 
                               doc.date || 
                               doc.date_document ||
                               doc.created_at || 
                               doc.date_creation;
                
                if (!docDate) {
                    return false;
                }
                const docDateObj = this.parseDate(docDate);
                if (!docDateObj || isNaN(docDateObj.getTime())) {
                    if (index < 3) {
                        console.log(`⚠️ [matchesDate] Impossible de parser la date pour ${item.reference}:`, docDate);
                    }
                    return false;
                }
                
                let matches = true;
                if (dateDu) {
                    const dateDuObj = this.parseDate(dateDu);
                    if (!dateDuObj || isNaN(dateDuObj.getTime())) {
                        return false;
                    }
                    dateDuObj.setHours(0, 0, 0, 0);
                    const docDateStart = new Date(docDateObj);
                    docDateStart.setHours(0, 0, 0, 0);
                    if (docDateStart < dateDuObj) {
                        matches = false;
                    }
                }
                if (dateJusqua && matches) {
                    const dateJusquaObj = this.parseDate(dateJusqua);
                    if (!dateJusquaObj || isNaN(dateJusquaObj.getTime())) {
                        return false;
                    }
                    dateJusquaObj.setHours(23, 59, 59, 999);
                    const docDateEnd = new Date(docDateObj);
                    docDateEnd.setHours(23, 59, 59, 999);
                    if (docDateEnd > dateJusquaObj) {
                        matches = false;
                    }
                }
                
                return matches;
            })();
            const matchesStatus = (() => {
                if (this.isConsolidationStatusFilter()) {
                    const id = Number(item?.id ?? itemAny?.fullData?.id ?? itemAny?.document_id);
                    return Number.isFinite(id) && id > 0 && this.factureIdsWithTicketsConsolides.has(id);
                }
                if (!this.filters.selectedStatuses || this.filters.selectedStatuses.length === 0) {
                    if (normalizedStatus === 'Tous') {
                        return true;
                    }
                    const itemNorm = this.normalizeStatus(item.status || '');
                    return (
                        item.status === normalizedStatus ||
                        itemNorm === normalizedStatus ||
                        itemNorm === this.normalizeStatus(normalizedStatus)
                    );
                }
                const statusMatch = this.filters.selectedStatuses.some((selectedStatus: string) => {
                    const normalizedSelected = this.normalizeStatus(selectedStatus);
                    const itemNorm = this.normalizeStatus(item.status || '');
                    return (
                        item.status === normalizedSelected ||
                        item.status === selectedStatus ||
                        itemNorm === normalizedSelected
                    );
                });

                
                return statusMatch;
            })();

            const allMatches = matchesSearch && matchesRaison && matchesMatricule && matchesChiffreAff &&
                   matchesClient && matchesEntrepot && matchesFournisseur && matchesProjet && matchesDate && matchesStatus;
            if (index < 3 && !allMatches && (this.clientDetailsScopeClientId != null || this.filters.client_id || this.filters.projet_id || (this.filters.selectedStatuses && this.filters.selectedStatuses.length > 0))) {
                console.log(`❌ [updateFilteredData] Document ${item.reference} exclu:`, {
                    matchesSearch,
                    matchesRaison,
                    matchesMatricule,
                    matchesChiffreAff,
                    matchesClient,
                    matchesFournisseur,
                    matchesProjet,
                    matchesDate,
                    matchesStatus,
                    itemStatus: item.status
                });
            }

            return allMatches;
        });
        this.filteredData.sort((a, b) => {
            const idA = a.id || 0;
            const idB = b.id || 0;
            return idB - idA;
        });
        
        if (this.filteredData.length !== this.archiveData.length) {
            console.log('✅ [updateFilteredData] Filtrage terminé:', {
                documentsAvant: this.archiveData.length,
                documentsApres: this.filteredData.length,
                filtresActifs: {
                    client_details_scope: this.clientDetailsScopeClientId,
                    client_id: this.filters.client_id,
                    fournisseur_id: this.filters.fournisseur_id,
                    projet_id: this.filters.projet_id,
                    selectedStatuses: this.filters.selectedStatuses
                }
            });
        }
        this.updateFilterSummary();
        this.updatePagination();
        this.cdr.detectChanges();
    }

    private normalizeStatus(status: string): string {
        if (!status) return status;

        const repaired = this.repairStatusEncoding(status);

        const statusMap: { [key: string]: string } = {
            tous: 'Tous',
            brouillon: 'Brouillon',
            valide: 'Valide',
            cree: 'Créé',
            créé: 'Créé',
            annule: 'Annulé',
            annulé: 'Annulé',
            annulee: 'Annulé',
            annulée: 'Annulé',
            négociation: 'Négociation',
            negociation: 'Négociation',
            fermé: 'Fermé',
            ferme: 'Fermé',
            accepte: 'Accepté',
            accepté: 'Accepté',
            payé: 'Payé',
            paye: 'Payé',
            payee: 'Payé',
            payée: 'Payé',
            'non payé': 'Non payé',
            'non paye': 'Non payé',
            'non_payé': 'Non payé',
            'non_paye': 'Non payé',
            'partiellement payé': 'Partiellement payé',
            'partiellement paye': 'Partiellement payé',
            livré: 'Livré',
            livre: 'Livré',
            sorti: 'Sorti',
            recu: 'Reçu',
            reçu: 'Reçu',
            'non utilisé': 'Non utilisé',
            'partiellement utilisé': 'Partiellement utilisé',
            utilisé: 'Utilisé'
        };

        const normalized = repaired
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .replace(/\s+/g, ' ');
        return statusMap[normalized] || statusMap[repaired.toLowerCase().trim()] || repaired;
    }

    updatePagination() {
        if (this.isLoading) {
            return;
        }
        
        this.totalPages = Math.ceil(this.filteredData.length / this.basicSelectedOption) || 1;
        this.currentPage = Math.min(this.currentPage, this.totalPages);
        this.pages = Array.from({length: this.totalPages}, (_, i) => i + 1);
        const start = (this.currentPage - 1) * this.basicSelectedOption;
        this.paginatedData = this.filteredData.slice(start, start + this.basicSelectedOption);
        if (!this.hasDataLoaded) {
            this.hasDataLoaded = true;
        }

        if (this.type === 'facture') {
            if (!this._skipFactureLinksReload) {
                this.loadFactureIdsWithTicketsConsolides();
            }
        }

        this.cdr.detectChanges();
    }

    generateWeekDays() {
        const today = new Date();
        const startOfWeek = new Date(this.selectedDate || today);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1);

        this.weekDays = Array.from({length: 7}, (_, i) => {
            const d = new Date(startOfWeek);
            d.setDate(startOfWeek.getDate() + i);
            return {
                label: d.toLocaleDateString('fr-FR', {weekday: 'short', day: '2-digit'}),
                dateString: formatLocalDateKey(d),
                isToday: d.toDateString() === today.toDateString()
            };
        });
    }

    selectDay(day: any) {
        this.selectedDay = day.dateString;
        const parsed = this.parseDate(day.dateString) || new Date();
        this.selectedDate = parsed;
        this.selectedMonthIndex = this.selectedDate.getMonth();
        this.selectedYear = this.selectedDate.getFullYear();
        this.dateFilterStart = day.dateString;
        this.dateFilterEnd = day.dateString;
        this.updateSelectedPeriod();
        if (this.datePicker?.nativeElement?._flatpickr) {
            this.datePicker.nativeElement._flatpickr.setDate([day.dateString, day.dateString], false);
        }
        this.applyDateFilter(day.dateString, day.dateString);
    }

    selectMonth(index: number) {
        this.selectedMonthIndex = index;
        const year = this.selectedYear !== null ? this.selectedYear : this.currentYear;
        const monthStart = formatLocalDateKey(new Date(year, index, 1));
        const monthEnd = formatLocalDateKey(new Date(year, index + 1, 0));
        this.dateFilterStart = monthStart;
        this.dateFilterEnd = monthEnd;
        this.selectedPeriod = `Mois: ${this.months[index]} ${year}`;
        this.selectedDate = new Date(year, index, 1);
        this.selectedYear = year;
        this.selectedDay = '';
        if (this.datePicker?.nativeElement?._flatpickr) {
            this.datePicker.nativeElement._flatpickr.setDate([monthStart, monthEnd], false);
        }
        this.applyDateFilter(monthStart, monthEnd);
    }

    selectYear(year: number) {
        this.selectedYear = year;
        if (this.viewMode === 'annees') {
            const yearStart = `${year}-01-01`;
            const yearEnd = `${year}-12-31`;
            this.dateFilterStart = yearStart;
            this.dateFilterEnd = yearEnd;
            this.selectedPeriod = `Année: ${year}`;
            this.selectedDate = new Date(year, 0, 1);
            this.selectedMonthIndex = null;
            this.selectedDay = '';
            if (this.datePicker?.nativeElement?._flatpickr) {
                this.datePicker.nativeElement._flatpickr.setDate([yearStart, yearEnd], false);
            }
            this.applyDateFilter(yearStart, yearEnd);
        } else if (this.viewMode === 'mois') {
            const monthIndex = this.selectedMonthIndex !== null ? this.selectedMonthIndex : this.currentMonthIndex;
            const monthStart = formatLocalDateKey(new Date(year, monthIndex, 1));
            const monthEnd = formatLocalDateKey(new Date(year, monthIndex + 1, 0));
            this.dateFilterStart = monthStart;
            this.dateFilterEnd = monthEnd;
            this.selectedPeriod = `Mois: ${this.months[monthIndex]} ${year}`;
            this.selectedDate = new Date(year, monthIndex, 1);
            this.selectedMonthIndex = monthIndex;
            if (this.datePicker?.nativeElement?._flatpickr) {
                this.datePicker.nativeElement._flatpickr.setDate([monthStart, monthEnd], false);
            }
            this.applyDateFilter(monthStart, monthEnd);
        } else {
            const yearStart = `${year}-01-01`;
            const yearEnd = `${year}-12-31`;
            this.dateFilterStart = yearStart;
            this.dateFilterEnd = yearEnd;
            this.selectedPeriod = `Année: ${year}`;
            this.applyDateFilter(yearStart, yearEnd);
        }
    }

    incrementDate() {
        if (this.selectedDate) {
            if (this.viewMode === 'mois') {
                this.selectedDate.setMonth(this.selectedDate.getMonth() + 1);
                const year = this.selectedDate.getFullYear();
                const monthIndex = this.selectedDate.getMonth();
                const monthStart = formatLocalDateKey(new Date(year, monthIndex, 1));
                const monthEnd = formatLocalDateKey(new Date(year, monthIndex + 1, 0));
                this.dateFilterStart = monthStart;
                this.dateFilterEnd = monthEnd;
                this.selectedPeriod = `Mois: ${this.months[monthIndex]} ${year}`;
                this.selectedMonthIndex = monthIndex;
                this.selectedYear = year;
                this.selectedDay = '';
                if (this.datePicker?.nativeElement?._flatpickr) {
                    this.datePicker.nativeElement._flatpickr.setDate([monthStart, monthEnd], false);
                }
                
                this.applyDateFilter(monthStart, monthEnd);
            } else if (this.viewMode === 'annees') {
                this.selectedDate.setFullYear(this.selectedDate.getFullYear() + 1);
                const year = this.selectedDate.getFullYear();
                const yearStart = `${year}-01-01`;
                const yearEnd = `${year}-12-31`;
                this.dateFilterStart = yearStart;
                this.dateFilterEnd = yearEnd;
                this.selectedPeriod = `Année: ${year}`;
                this.selectedYear = year;
                this.selectedMonthIndex = null;
                this.selectedDay = '';
                if (this.datePicker?.nativeElement?._flatpickr) {
                    this.datePicker.nativeElement._flatpickr.setDate([yearStart, yearEnd], false);
                }
                
                this.applyDateFilter(yearStart, yearEnd);
            } else {
                this.selectedDate.setDate(this.selectedDate.getDate() + 1);
                const dayToUse = formatLocalDateKey(this.selectedDate);
                this.selectedDay = dayToUse;
                this.dateFilterStart = dayToUse;
                this.dateFilterEnd = dayToUse;
                this.selectedMonthIndex = this.selectedDate.getMonth();
                this.selectedYear = this.selectedDate.getFullYear();
                this.updateSelectedPeriod();
                if (this.datePicker?.nativeElement?._flatpickr) {
                    this.datePicker.nativeElement._flatpickr.setDate([dayToUse, dayToUse], false);
                }
                
                this.applyDateFilter(dayToUse, dayToUse);
            }
            this.generateWeekDays();
            this.cdr.detectChanges();
        }
    }

    decrementDate() {
        if (this.selectedDate) {
            if (this.viewMode === 'mois') {
                this.selectedDate.setMonth(this.selectedDate.getMonth() - 1);
                const year = this.selectedDate.getFullYear();
                const monthIndex = this.selectedDate.getMonth();
                const monthStart = formatLocalDateKey(new Date(year, monthIndex, 1));
                const monthEnd = formatLocalDateKey(new Date(year, monthIndex + 1, 0));
                this.dateFilterStart = monthStart;
                this.dateFilterEnd = monthEnd;
                this.selectedPeriod = `Mois: ${this.months[monthIndex]} ${year}`;
                this.selectedMonthIndex = monthIndex;
                this.selectedYear = year;
                this.selectedDay = '';
                if (this.datePicker?.nativeElement?._flatpickr) {
                    this.datePicker.nativeElement._flatpickr.setDate([monthStart, monthEnd], false);
                }
                
                this.applyDateFilter(monthStart, monthEnd);
            } else if (this.viewMode === 'annees') {
                this.selectedDate.setFullYear(this.selectedDate.getFullYear() - 1);
                const year = this.selectedDate.getFullYear();
                const yearStart = `${year}-01-01`;
                const yearEnd = `${year}-12-31`;
                this.dateFilterStart = yearStart;
                this.dateFilterEnd = yearEnd;
                this.selectedPeriod = `Année: ${year}`;
                this.selectedYear = year;
                this.selectedMonthIndex = null;
                this.selectedDay = '';
                if (this.datePicker?.nativeElement?._flatpickr) {
                    this.datePicker.nativeElement._flatpickr.setDate([yearStart, yearEnd], false);
                }
                
                this.applyDateFilter(yearStart, yearEnd);
            } else {
                this.selectedDate.setDate(this.selectedDate.getDate() - 1);
                const dayToUse = formatLocalDateKey(this.selectedDate);
                this.selectedDay = dayToUse;
                this.dateFilterStart = dayToUse;
                this.dateFilterEnd = dayToUse;
                this.selectedMonthIndex = this.selectedDate.getMonth();
                this.selectedYear = this.selectedDate.getFullYear();
                this.updateSelectedPeriod();
                if (this.datePicker?.nativeElement?._flatpickr) {
                    this.datePicker.nativeElement._flatpickr.setDate([dayToUse, dayToUse], false);
                }
                
                this.applyDateFilter(dayToUse, dayToUse);
            }
            this.generateWeekDays();
            this.cdr.detectChanges();
        }
    }

    initializeFlatpickr() {
        if (this.datePicker) {
            const today = new Date();
            const defaultDate = this.dateFilterStart && this.dateFilterEnd 
                ? [new Date(this.dateFilterStart), new Date(this.dateFilterEnd)]
                : [today, today];
            
            flatpickr(this.datePicker.nativeElement, {
                locale: French,
                mode: 'range',
                dateFormat: 'Y-m-d',
                defaultDate: defaultDate,
                allowInput: true,
                onChange: (selectedDates, dateStr, instance) => {
                    if (selectedDates.length === 1) {
                        const singleDate = formatLocalDateKey(selectedDates[0]);
                        this.dateFilterStart = singleDate;
                        this.dateFilterEnd = singleDate;
                        this.selectedPeriod = this.formatPeriodJour(selectedDates[0]);
                        this.selectedDay = singleDate;
                        this.selectedDate = selectedDates[0];
                        this.selectedMonthIndex = selectedDates[0].getMonth();
                        this.selectedYear = selectedDates[0].getFullYear();
                        
                        this.applyDateFilter(singleDate, singleDate);
                    } else if (selectedDates.length === 2) {
                        const startDate = formatLocalDateKey(selectedDates[0]);
                        const endDate = formatLocalDateKey(selectedDates[1]);
                        this.dateFilterStart = startDate;
                        this.dateFilterEnd = endDate;
                        const a = selectedDates[0];
                        const b = selectedDates[1];
                        this.selectedPeriod = `Du ${a.getDate()} ${this.months[a.getMonth()]} ${a.getFullYear()} au ${b.getDate()} ${this.months[b.getMonth()]} ${b.getFullYear()}`;
                        this.selectedMonthIndex = null;
                        this.selectedDay = '';
                        this.selectedYear = null;
                        this.selectedDate = null;
                        
                        this.applyDateFilter(startDate, endDate);
                    } else {
                        this.dateFilterStart = '';
                        this.dateFilterEnd = '';
                        this.selectedPeriod = '';
                        this.resetDateFilters();
                    }
                },
                onClose: (selectedDates, dateStr, instance) => {
                    if (selectedDates.length === 1) {
                        const singleDate = formatLocalDateKey(selectedDates[0]);
                        this.dateFilterStart = singleDate;
                        this.dateFilterEnd = singleDate;
                        this.applyDateFilter(singleDate, singleDate);
                    }
                }
            });
        }
    }

    private initDefaultDateFilter(): void {
        const today = new Date();
        const day = todayLocalDateKey();
        this.selectedDate = today;
        this.selectedDay = day;
        this.dateFilterStart = day;
        this.dateFilterEnd = day;
        this.selectedMonthIndex = today.getMonth();
        this.selectedYear = today.getFullYear();
        this.viewMode = 'jours';
        this.updateSelectedPeriod();
        this.generateWeekDays();
        this.dataService.setDateRangeFilter(this.dateFilterStart, this.dateFilterEnd);
    }

    /** Restaure le calendrier : défaut = aujourd’hui (date locale), pas une plage UTC obsolète. */
    private restoreDateFilterState(): void {
        // Toujours démarrer sur aujourd'hui (comme /tiers/ticketCaisse) pour /vente/facture/tous etc.
        this.initDefaultDateFilter();
        this.persistDateFilterState();
    }

    private persistDateFilterState(): void {
        saveDocumentDateFilter({
            viewMode: this.viewMode as DocumentDateViewMode,
            dateFilterStart: this.dateFilterStart,
            dateFilterEnd: this.dateFilterEnd,
            selectedDay: this.selectedDay,
            selectedMonthIndex: this.selectedMonthIndex,
            selectedYear: this.selectedYear,
        });
        this.dataService.setDateRangeFilter(this.dateFilterStart, this.dateFilterEnd);
    }

    private applyDateFilter(startDate: string, endDate: string): void {
        this.dateFilterStart = startDate;
        this.dateFilterEnd = endDate;
        this.persistDateFilterState();
        if (this.type === 'inventaire' || this.type === 'bon-transfert') {
            this.loadStockDocuments();
        } else {
            const normalizedStatus = this.normalizeStatus(this.status);
            this.reloadDocumentsForCurrentList(normalizedStatus);
        }
        
        this.updateFilterSummary();
        this.cdr.detectChanges();
    }

    private resetDateFilters(): void {
        const today = new Date();
        this.dateFilterStart = formatLocalDateKey(today);
        this.dateFilterEnd = formatLocalDateKey(today);
        this.selectedDay = formatLocalDateKey(today);
        this.selectedDate = today;
        this.selectedMonthIndex = today.getMonth();
        this.selectedYear = today.getFullYear();
        this.updateSelectedPeriod();
        this.applyDateFilter(this.dateFilterStart, this.dateFilterEnd);
    }

    initializeFilterDatePickers() {
        setTimeout(() => {
            if (this.dateDuVente?.nativeElement && this.dateJusquaVente?.nativeElement) {
                this.initDateRangePicker(this.dateDuVente.nativeElement, this.dateJusquaVente.nativeElement);
            }
            if (this.dateDuAchat?.nativeElement && this.dateJusquaAchat?.nativeElement) {
                this.initDateRangePicker(this.dateDuAchat.nativeElement, this.dateJusquaAchat.nativeElement);
            }
            if (this.dateDuStock?.nativeElement && this.dateJusquaStock?.nativeElement) {
                this.initDateRangePicker(this.dateDuStock.nativeElement, this.dateJusquaStock.nativeElement);
            }
        }, 500);
        this.initializeSelects();
    }
    
    initializeSelects() {
        setTimeout(() => {
            const selects = document.querySelectorAll('.filter-sidebar .filter-select:not(.filter-ng-select)');
            selects.forEach((select: any) => {
                select.addEventListener('focus', () => {
                    select.style.borderColor = '#134ad3';
                    select.style.boxShadow = '0 0 0 3px rgba(19, 74, 211, 0.1)';
                });
                
                select.addEventListener('blur', () => {
                    select.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
                });
                
                select.addEventListener('mousedown', () => {
                    select.style.borderColor = '#134ad3';
                });
            });
        }, 100);
    }

    initDateRangePicker(startInput: HTMLElement, endInput: HTMLElement) {
        const container = startInput.parentElement?.parentElement;
        if (!container) {
            return;
        }
        const rangeInput = document.createElement('input');
        rangeInput.type = 'text';
        rangeInput.style.position = 'absolute';
        rangeInput.style.opacity = '0';
        rangeInput.style.pointerEvents = 'none';
        rangeInput.style.width = '1px';
        rangeInput.style.height = '1px';
        rangeInput.style.border = 'none';
        rangeInput.style.padding = '0';
        rangeInput.style.margin = '0';
        rangeInput.style.zIndex = '-1';
        if (window.getComputedStyle(container).position === 'static') {
            container.style.position = 'relative';
        }
        container.appendChild(rangeInput);
        const fp = flatpickr(rangeInput, {
            locale: French,
            mode: 'range',
            dateFormat: 'Y-m-d',
            allowInput: false,
            clickOpens: true,
            static: false,
            appendTo: container,
            onChange: (selectedDates, dateStr) => {
                if (selectedDates.length === 2) {
                    const startDate = formatLocalDateKey(selectedDates[0]);
                    const endDate = formatLocalDateKey(selectedDates[1]);
                    this.filters.date_du = startDate;
                    this.filters.date_jusqua = endDate;
                    (startInput as HTMLInputElement).value = this.formatDate(startDate);
                    (endInput as HTMLInputElement).value = this.formatDate(endDate);
                    this.updateFilteredData();
                    this.cdr.detectChanges();
                } else if (selectedDates.length === 1) {
                    const startDate = formatLocalDateKey(selectedDates[0]);
                    this.filters.date_du = startDate;
                    (startInput as HTMLInputElement).value = this.formatDate(startDate);
                    this.filters.date_jusqua = '';
                    (endInput as HTMLInputElement).value = '';
                } else {
                    this.filters.date_du = '';
                    this.filters.date_jusqua = '';
                    (startInput as HTMLInputElement).value = '';
                    (endInput as HTMLInputElement).value = '';
                }
            }
        });
        const openCalendar = (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            fp.open();
            setTimeout(() => {
                const calendar = document.querySelector('.flatpickr-calendar');
                if (calendar) {
                    (calendar as HTMLElement).style.display = 'block';
                    (calendar as HTMLElement).style.zIndex = '99999';
                    (calendar as HTMLElement).style.visibility = 'visible';
                    (calendar as HTMLElement).style.opacity = '1';
                } else {
                    console.warn('⚠️ Calendrier non trouvé dans le DOM');
                }
            }, 100);
        };
        startInput.addEventListener('click', openCalendar, false);
        startInput.addEventListener('focus', openCalendar, false);
        endInput.addEventListener('click', openCalendar, false);
        endInput.addEventListener('focus', openCalendar, false);
        (startInput as HTMLInputElement).addEventListener('keydown', (e) => {
            e.preventDefault();
            openCalendar(e);
        });
        (endInput as HTMLInputElement).addEventListener('keydown', (e) => {
            e.preventDefault();
            openCalendar(e);
        });
        if (this.filters.date_du && this.filters.date_jusqua) {
            fp.setDate([this.filters.date_du, this.filters.date_jusqua], false);
            (startInput as HTMLInputElement).value = this.formatDate(this.filters.date_du);
            (endInput as HTMLInputElement).value = this.formatDate(this.filters.date_jusqua);
        } else if (this.filters.date_du) {
            fp.setDate([this.filters.date_du], false);
            (startInput as HTMLInputElement).value = this.formatDate(this.filters.date_du);
        }
        (startInput as any)._flatpickr = fp;
        (endInput as any)._flatpickr = fp;
        (rangeInput as any)._flatpickr = fp;

    }

    resetFilters() {
        this.filters = {
            raison: '',
            matricule: '',
            chiffre_aff: '',
            operator: '=',
            client_id: null,
            fournisseur_id: null,
            projet_id: null,
            entrepot_id: null,
            date_du: '',
            date_jusqua: '',
            selectedStatuses: []
        };
        this.searchTerm = '';
        this.status = 'Tous';

        const today = new Date();
        this.selectedDate = today;
        this.selectedDay = formatLocalDateKey(today);
        this.selectedMonthIndex = today.getMonth();
        this.selectedYear = today.getFullYear();
        this.dateFilterStart = formatLocalDateKey(today);
        this.dateFilterEnd = formatLocalDateKey(today);
        this.updateSelectedPeriod();

        const dateRefs = [
            this.dateDuVente,
            this.dateJusquaVente,
            this.dateDuAchat,
            this.dateJusquaAchat,
            this.dateDuStock,
            this.dateJusquaStock,
        ];
        dateRefs.forEach((ref) => {
            const el = ref?.nativeElement as (HTMLInputElement & { _flatpickr?: any }) | undefined;
            if (!el) return;
            el.value = '';
            if (el._flatpickr) {
                el._flatpickr.clear();
            }
        });
        if (this.datePicker?.nativeElement?._flatpickr) {
            this.datePicker.nativeElement._flatpickr.setDate([today, today], true);
        }

        if (this.showFilter) {
            this.toggleFilter();
        }

        if (this.type === 'inventaire' || this.type === 'bon-transfert') {
            this.loadStockDocuments();
        } else {
            this.applyDateFilter(this.selectedDay, this.selectedDay);
        }

        this.updateFilteredData();
        setTimeout(() => {
            Feather.replace();
            this.cdr.detectChanges();
        }, 100);
        this.cdr.detectChanges();
    }

    /** Libellé période « Jour: … » (même famille que « Mois: … », « Année: … »). */
    private formatPeriodJour(d: Date): string {
        return `Jour: ${d.getDate()} ${this.months[d.getMonth()]} ${d.getFullYear()}`;
    }

    updateSelectedPeriod() {
        const dateToUse = this.selectedDate || new Date();
        const year = dateToUse.getFullYear();
        if (this.viewMode === 'mois' && this.selectedMonthIndex !== null) {
            const selectedYear = this.selectedYear || year;
            this.selectedPeriod = `Mois: ${this.months[this.selectedMonthIndex]} ${selectedYear}`;
        } else if (this.viewMode === 'annees' && this.selectedYear !== null) {
            this.selectedPeriod = `Année: ${this.selectedYear}`;
        } else {
            this.selectedPeriod = this.formatPeriodJour(dateToUse);
        }
    }

    toggleFilter(): void {
        this.showFilter = !this.showFilter;
    }

    onSearch() {
        this.updateFilteredData();
        this.cdr.detectChanges();
    }

    onProjetFilterChange(): void {
        if (this.filters.projet_id === '' || this.filters.projet_id === null || this.filters.projet_id === undefined) {
            this.filters.projet_id = null;
        } else if (typeof this.filters.projet_id === 'string') {
            const projetIdNum = parseInt(this.filters.projet_id, 10);
            if (!isNaN(projetIdNum)) {
                this.filters.projet_id = projetIdNum;
            } else {
                this.filters.projet_id = null;
            }
        }
        this.updateFilteredData();
        this.cdr.detectChanges();
    }

    openFlatpickr() {
        if (this.datePicker?.nativeElement?._flatpickr) {
            this.datePicker.nativeElement._flatpickr.open();
        }
    }

    formatDate(dateString: string) {
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR');
    }

    updateFilterSummary() {
        const activeFilters: string[] = [];
        if (this.filters.raison) {
            activeFilters.push(`Raison: ${this.filters.raison}`);
        }
        if (this.filters.matricule) {
            activeFilters.push(`Matricule: ${this.filters.matricule}`);
        }
        if (this.filters.chiffre_aff) {
            activeFilters.push(`Chiffre: ${this.filters.operator} ${this.filters.chiffre_aff}`);
        }
        if (this.status !== 'Tous') {
            activeFilters.push(`Statut: ${this.status}`);
        }
        if (this.selectedPeriod) {
            activeFilters.push(this.selectedPeriod);
        }
        this.filterSummary = activeFilters.join(', ');
    }

    applyFilters() {
        if (this.filters.client_id && typeof this.filters.client_id !== 'number') {
            this.filters.client_id = parseInt(String(this.filters.client_id)) || null;
        }
        if (this.filters.fournisseur_id && typeof this.filters.fournisseur_id !== 'number') {
            this.filters.fournisseur_id = parseInt(String(this.filters.fournisseur_id)) || null;
        }
        if (this.filters.projet_id && typeof this.filters.projet_id !== 'number') {
            this.filters.projet_id = parseInt(String(this.filters.projet_id)) || null;
        }
        if (this.filters.entrepot_id && typeof this.filters.entrepot_id !== 'number') {
            this.filters.entrepot_id = parseInt(String(this.filters.entrepot_id)) || null;
        }
        
        this.updateFilteredData();
        this.getActiveFilters();
        this.toggleFilter();
        this.cdr.detectChanges();
        setTimeout(() => {
            Feather.replace();
            this.cdr.detectChanges();
        }, 100);
    }

    getActiveFilters(): Array<{key: string, label: string, value: any}> {
        const activeFilters: Array<{key: string, label: string, value: any}> = [];
        const isAchat = this.baseRoute === '/achat';
        if (this.filters.client_id && !isAchat) {
            const client = this.clients.find(c => c.id === parseInt(String(this.filters.client_id)));
            if (client) {
                activeFilters.push({
                    key: 'client_id',
                    label: 'Client',
                    value: client.nom_prenom  || 'Client'
                });
            }
        }
        if (this.filters.fournisseur_id) {
            const fournisseur = this.fournisseurs.find(f => f.id === parseInt(String(this.filters.fournisseur_id)));
            if (fournisseur) {
                activeFilters.push({
                    key: 'fournisseur_id',
                    label: 'Fournisseur',
                    value: fournisseur.nom_entreprise || 'Fournisseur'
                });
            }
        }
        if (this.filters.entrepot_id && this.type === 'inventaire') {
            const entrepot = this.entrepots.find((e: any) => e.id === parseInt(String(this.filters.entrepot_id)));
            if (entrepot) {
                activeFilters.push({
                    key: 'entrepot_id',
                    label: 'Entrepôt',
                    value: entrepot.nom || entrepot.libelle || entrepot.code || entrepot.code_entrepot || 'Entrepôt'
                });
            }
        }
        if (this.filters.projet_id) {
            const projet = this.projects.find(p => p.id === parseInt(String(this.filters.projet_id)));
            if (projet) {
                activeFilters.push({
                    key: 'projet_id',
                    label: 'Projet',
                    value: projet.libelle || 'Projet'
                });
            }
        }
        if (this.filters.selectedStatuses && this.filters.selectedStatuses.length > 0) {
            this.filters.selectedStatuses.forEach((status: string) => {
                activeFilters.push({
                    key: 'status_' + status,
                    label: 'État',
                    value: status
                });
            });
        }
        if (this.filters.raison) {
            activeFilters.push({
                key: 'raison',
                label: 'Raison sociale',
                value: this.filters.raison
            });
        }
        if (this.filters.matricule) {
            activeFilters.push({
                key: 'matricule',
                label: 'Matricule',
                value: this.filters.matricule
            });
        }
        if (this.filters.chiffre_aff) {
            const operatorLabel = this.filters.operator === '=' ? '=' : this.filters.operator === '>' ? '>' : '<';
            activeFilters.push({
                key: 'chiffre_aff',
                label: 'Montant',
                value: `${operatorLabel} ${this.filters.chiffre_aff} TND`
            });
        }
        if (this.filters.date_du || this.filters.date_jusqua) {
            let dateValue = '';
            if (this.filters.date_du && this.filters.date_jusqua) {
                dateValue = `${this.formatDate(this.filters.date_du)} - ${this.formatDate(this.filters.date_jusqua)}`;
            } else if (this.filters.date_du) {
                dateValue = `À partir du ${this.formatDate(this.filters.date_du)}`;
            } else if (this.filters.date_jusqua) {
                dateValue = `Jusqu'au ${this.formatDate(this.filters.date_jusqua)}`;
            }
            if (dateValue) {
                activeFilters.push({
                    key: 'date',
                    label: 'Date',
                    value: dateValue
                });
            }
        }

        return activeFilters;
    }

    removeFilter(filterKey: string, event?: Event): void {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        
        if (filterKey === 'date') {
            this.filters.date_du = '';
            this.filters.date_jusqua = '';
            if (this.dateDuVente?.nativeElement) {
                (this.dateDuVente.nativeElement as HTMLInputElement).value = '';
            }
            if (this.dateJusquaVente?.nativeElement) {
                (this.dateJusquaVente.nativeElement as HTMLInputElement).value = '';
            }
            if (this.dateDuAchat?.nativeElement) {
                (this.dateDuAchat.nativeElement as HTMLInputElement).value = '';
            }
            if (this.dateJusquaAchat?.nativeElement) {
                (this.dateJusquaAchat.nativeElement as HTMLInputElement).value = '';
            }
            if (this.dateDuStock?.nativeElement) {
                (this.dateDuStock.nativeElement as HTMLInputElement).value = '';
            }
            if (this.dateJusquaStock?.nativeElement) {
                (this.dateJusquaStock.nativeElement as HTMLInputElement).value = '';
            }
            if (this.dateDuVente?.nativeElement?._flatpickr) {
                this.dateDuVente.nativeElement._flatpickr.clear();
            }
            if (this.dateDuAchat?.nativeElement?._flatpickr) {
                this.dateDuAchat.nativeElement._flatpickr.clear();
            }
        } else if (filterKey === 'chiffre_aff') {
            this.filters.chiffre_aff = '';
            this.filters.operator = '=';
        } else if (filterKey.startsWith('status_')) {
            const statusToRemove = filterKey.replace('status_', '');
            if (this.filters.selectedStatuses) {
                const index = this.filters.selectedStatuses.indexOf(statusToRemove);
                if (index > -1) {
                    this.filters.selectedStatuses.splice(index, 1);
                }
            }
        } else {
            this.filters[filterKey] = '';
        }
        
        this.updateFilteredData();
        this.cdr.detectChanges();
        setTimeout(() => {
            Feather.replace();
            this.cdr.detectChanges();
        }, 100);
    }

    trackByFilterKey(index: number, filter: {key: string, label: string, value: any}): string {
        return filter.key;
    }

    toggleStatusFilter(status: string): void {
        if (!this.filters.selectedStatuses) {
            this.filters.selectedStatuses = [];
        }
        
        const index = this.filters.selectedStatuses.indexOf(status);
        
        if (index > -1) {
            this.filters.selectedStatuses.splice(index, 1);
        } else {
            this.filters.selectedStatuses.push(status);
        }
        if (status === 'Tous') {
            if (index > -1) {
                this.filters.selectedStatuses = [];
            } else {
                this.filters.selectedStatuses = ['Tous'];
            }
        } else {
            const tousIndex = this.filters.selectedStatuses.indexOf('Tous');
            if (tousIndex > -1) {
                this.filters.selectedStatuses.splice(tousIndex, 1);
            }
        }
        this.updateFilteredData();
        this.cdr.detectChanges();
    }

    isStatusSelected(status: string): boolean {
        if (!this.filters.selectedStatuses || this.filters.selectedStatuses.length === 0) {
            return status === 'Tous' && this.status === 'Tous';
        }
        return this.filters.selectedStatuses.includes(status);
    }

    changePage(page: number) {
        this.currentPage = page;
        this.updatePagination();
        this.cdr.detectChanges();
    }

    sendEmail(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        if ('email' in item && item.email) {
            this.toastr.success(`Email envoyé à ${item.email}`);
        } else {
            this.toastr.error('Aucune adresse email disponible pour cet élément.');
        }
    }

    openPhoneModal(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        if ('phoneNumbers' in item && item.phoneNumbers?.length) {
            this.selectedItem = item;
            this.modalRef = this.modalService.open(this.phoneModal, {
                ariaLabelledBy: 'modal-basic-title',
                centered: true,
                size: 'md',
                windowClass: 'phone-modal-centered',
                backdrop: 'static'
            });
            setTimeout(() => Feather.replace(), 0);
        } else {
            this.toastr.error('Aucun numéro de téléphone disponible pour cet élément.');
        }
    }

    openSmsModal(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        if ('phoneNumbers' in item && item.phoneNumbers?.length) {
            const smsModalTemplate = this.smsModalComponent.getModalTemplate();
            this.modalRef = this.modalService.open(smsModalTemplate, {
                centered: true,
                size: 'lg',
                backdrop: 'static'
            });
            setTimeout(() => Feather.replace(), 0);
        } else {
            this.toastr.error('Aucun numéro de téléphone disponible pour cet élément.');
        }
    }

    viewItem(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        const ref = item.reference ?? item.id;
        this.router.navigate([`/bibliotheque-clients/details/${ref}/detail-contenue-document/${this.type}`]);
    }

    editItem(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        this.router.navigate([`/tiers/clients/edit-client/${item.reference}`]);
    }

    openImportModal() {
        this.fileUploadModal.openModal();
    }

    openConvertModal(item?: any) {
        if (!this.type) {
            this.toastr.error('Type de document inconnu.');
            return;
        }
        const selectedDoc = item || this.selectedItem;

        if (!selectedDoc) {
            this.toastr.error('Document invalide ou ID manquant pour la conversion.');
            return;
        }
        const documentId = selectedDoc.id || selectedDoc.document_id || selectedDoc.documentId;

        if (!documentId) {
            this.toastr.error('Document invalide ou ID manquant pour la conversion.');
            return;
        }

        this.convertModal.openModal(this.type as any, documentId);
    }

    onConversionSuccess(event: {documentId: number, newType: string}): void {
        this.redirectToNewDocumentEdit(event.documentId, event.newType);
    }

    stayOnCurrentPage(): void {
        if (this.modalRef) {
            this.modalRef.close();
        }
        this.refreshDataAfterConversion();

        this.conversionResult = null;
    }
    private redirectToNewDocumentEdit(newDocumentId: number, newType: string): void {
        if (!newDocumentId || !newType) {
            this.toastr.error('Erreur: Impossible de rediriger vers le nouveau document', 'Erreur');
            return;
        }
        const normalizeType = (type: string): string => {
            return type.toLowerCase().trim();
        };

        const normalizedNewType = normalizeType(newType);
        if (normalizedNewType === 'inventaire') {
            this.router.navigate(['/inventaire', 'ajout-inventaire'], {
                queryParams: { id: newDocumentId }
            });
            return;
        }
        if (normalizedNewType === 'bon transfert' || normalizedNewType === 'bon-transfert') {
            this.router.navigate(['/bon-transfert', 'ajout-bonTransfert'], {
                queryParams: { id: newDocumentId }
            });
            return;
        }

        const typeRouteMap: { [key: string]: string } = {
            'devis': 'devis',
            'commande': 'commande-client',
            'commande client': 'commande-client',
            'bon de livraison': 'bon-livraison',
            'bon livraison': 'bon-livraison',
            'facture': 'facture',
            'avoir': 'facture',
            'bon de sortie': 'bon-sortie',
            'bon sortie': 'bon-sortie',
            'commande fournisseur': 'commande-fournisseur',
            'bon reception': 'bon-reception',
            'bon de réception': 'bon-reception',
            'facture fournisseur': 'facture-fournisseur',
            'retour fournisseur': 'retour-fournisseur'
        };
        let newTypeRoute = typeRouteMap[normalizedNewType];

        if (!newTypeRoute) {
            newTypeRoute = normalizedNewType
                .replace(/\s+/g, '-')
                .replace(/é/g, 'e')
                .replace(/è/g, 'e');
        }

        const basePath = this.getBaseRoute();
        this.router.navigate([basePath, newTypeRoute, 'edit-' + newTypeRoute], {
            queryParams: { id: newDocumentId }
        });
    }

    redirectToNewPage(): void {
        if (!this.conversionResult) {
            return;
        }

        if (this.modalRef) {
            this.modalRef.close();
        }
        const normalizeType = (type: string): string => {
            return type.toLowerCase().trim();
        };

        const normalizedNewType = normalizeType(this.conversionResult.newType);
        if (normalizedNewType === 'inventaire') {
            this.router.navigate(['/inventaire'], {
                queryParams: {}
            });
            this.conversionResult = null;
            return;
        }
        if (normalizedNewType === 'bon transfert' || normalizedNewType === 'bon-transfert') {
            this.router.navigate(['/bon-transfert'], {
                queryParams: {}
            });
            this.conversionResult = null;
            return;
        }

        const typeRouteMap: { [key: string]: string } = {
            'devis': 'devis',
            'commande': 'commande-client',
            'commande client': 'commande-client',
            'bon de livraison': 'bon-livraison',
            'bon livraison': 'bon-livraison',
            'facture': 'facture',
            'avoir': 'facture',
            'bon de sortie': 'bon-sortie',
            'bon sortie': 'bon-sortie',
            'commande fournisseur': 'commande-fournisseur',
            'bon reception': 'bon-reception',
            'bon de réception': 'bon-reception',
            'facture fournisseur': 'facture-fournisseur',
            'retour fournisseur': 'retour-fournisseur'
        };
        let newTypeRoute = typeRouteMap[normalizedNewType];

        if (!newTypeRoute) {
            newTypeRoute = normalizedNewType
                .replace(/\s+/g, '-')
                .replace(/é/g, 'e')
                .replace(/è/g, 'e');
        }

        const basePath = this.getBaseRoute();
        this.router.navigate([basePath, newTypeRoute], {
            queryParams: {}
        });

        this.conversionResult = null;
    }

    private refreshDataAfterConversion(): void {
        this.reloadAchatDataByCurrentScope(this.normalizeStatus(this.status || 'Tous'));
        const dataObservable = this.getDataObservable();
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
        this.isLoading = true;
        this.cdr.detectChanges();

        this.dataSubscription = dataObservable.subscribe({
            next: (data) => {
                const filtered = this.applyTypeFilterForArchive(data || []);
                this.archiveData = this.deduplicateDocumentsById(filtered);
                this.updateFilteredData();
                this.calculateFactureTotals();
                if (this.type === 'facture' || this.type === 'facture-fournisseur' || this.type === 'retour-fournisseur') {
                    this.loadFactureIdsWithAvoirNonPaye();
                }
                this.isLoading = false;
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.isLoading = false;
                this.toastr.error('Erreur lors du rafraîchissement des données', 'Erreur');
                this.cdr.detectChanges();
            }
        });
    }


    openDetailModal() {
        if (['devis', 'commande-client', 'facture', 'avoir', 'bon-livraison', 'bon-sortie'].includes(this.type!)) {
            this.detailVenteComponent.openModal();
        } else if (['commande-fournisseur', 'bon-reception', 'facture-fournisseur', 'retour-fournisseur', 'avoir-fournisseur'].includes(this.type!)) {
            this.detailCommandeFournisseurModal.openModal();
        }
    }

    openDetailModalForItem(item: any): void {
        this.selectedItem = item;
        const documentId = item?.id || item?.document_id || item?.documentId;
        if (!documentId) {
            this.toastr.error('ID du document manquant');
            return;
        }

        if (['devis', 'commande-client', 'facture', 'avoir', 'bon-livraison', 'bon-sortie'].includes(this.type!)) {
            this.detailVenteComponent.openModal(documentId);
        } else if (['commande-fournisseur', 'bon-reception', 'facture-fournisseur', 'retour-fournisseur', 'avoir-fournisseur'].includes(this.type!)) {
            this.detailCommandeFournisseurModal.openModal(documentId);
        } else if (['inventaire', 'bon-transfert'].includes(this.type!)) {
            this.detailInventaireModal.openModal(documentId);
        }
    }

    onDownloadDocumentFromDetail(event: { id: number }): void {
        if (event?.id) {
            this.downloadApproveVentePDF({ id: event.id } as any);
        }
    }

    loadFactureIdsWithTicketsConsolides(): void {
        if (this.type !== 'facture') {
            this.factureIdsWithTicketsConsolides = new Set();
            return;
        }
        if (!this.lcAuthService.isAuthenticated()) {
            this.factureIdsWithTicketsConsolides = new Set();
            return;
        }
        // Onglet Consolidation : besoin de tous les IDs liés. Sinon : page courante (icône œil).
        const useAllLinked = this.isConsolidationStatusFilter();
        const pageIds = useAllLinked
            ? []
            : (this.paginatedData || [])
                .map((item: any) => Number(item?.id ?? item?.fullData?.id ?? item?.document_id))
                .filter((id) => Number.isFinite(id) && id > 0);
        if (!useAllLinked && !pageIds.length) {
            this.factureIdsWithTicketsConsolides = new Set();
            return;
        }
        this.erpFactureLinksSub?.unsubscribe();
        this.erpFactureLinksSub = this.lcTicketService.getErpFactureLinks(useAllLinked ? undefined : pageIds).pipe(
            catchError(() => of([] as number[]))
        ).subscribe((linkedIds) => {
            this.factureIdsWithTicketsConsolides = new Set(linkedIds || []);
            if (useAllLinked) {
                this._skipFactureLinksReload = true;
                this.updateFilteredData();
                this._skipFactureLinksReload = false;
            } else {
                this.cdr.detectChanges();
                setTimeout(() => Feather.replace(), 0);
            }
        });
    }

    private _skipFactureLinksReload = false;

    /** Filtre « Consolidation » : factures liées à des tickets de caisse (pas un statut ERP). */
    private isConsolidationStatusFilter(): boolean {
        const s = (this.status || '').toString().trim().toLowerCase();
        return s === 'consolidation' || s === 'facture de consolidation';
    }

    hasTicketsConsolides(item: any): boolean {
        const id = Number(item?.id ?? item?.fullData?.id ?? item?.document_id);
        return Number.isFinite(id) && id > 0 && this.factureIdsWithTicketsConsolides.has(id);
    }

    openTicketsConsolides(item: any): void {
        const id = Number(item?.id ?? item?.fullData?.id ?? item?.document_id);
        if (!Number.isFinite(id) || id <= 0) {
            return;
        }
        const returnUrl = this.router.url || '/vente/facture/tous';
        void this.router.navigate(['/vente/facture/tickets-consolides'], {
            queryParams: { id, return: returnUrl },
        });
    }

    loadFactureIdsWithAvoirNonPaye(): void {
        if (this.type !== 'facture' && this.type !== 'facture-fournisseur' && this.type !== 'retour-fournisseur') {
            this.factureIdsWithAvoirNonPaye = new Set();
            return;
        }
        const typeDocumentId = this.getTypeDocumentId(this.type);
        forkJoin({
            nonUtilise: this.documentService.getByStatutAndType(this.STATUT_AVOIR_NON_UTILISE, typeDocumentId),
            partiellementUtilise: this.documentService.getByStatutAndType(this.STATUT_AVOIR_PARTIELLEMENT_UTILISE, typeDocumentId)
        }).pipe(
            map(({ nonUtilise, partiellementUtilise }) => {
                const toList = (r: any) => r?.data?.documents ?? r?.data ?? (Array.isArray(r) ? r : []);
                const list1 = Array.isArray(toList(nonUtilise)) ? toList(nonUtilise) : [];
                const list2 = Array.isArray(toList(partiellementUtilise)) ? toList(partiellementUtilise) : [];
                const ids = new Set<number>();
                [...list1, ...list2].forEach((doc: any) => {
                    const d = doc.fullData ?? doc;
                    const originalId = d?.document_original_id != null ? Number(d.document_original_id) : null;
                    if (originalId != null) ids.add(originalId);
                });
                return ids;
            })
        ).subscribe({
            next: (ids) => {
                this.factureIdsWithAvoirNonPaye = ids;
                this.cdr.detectChanges();
            },
            error: () => {
                this.factureIdsWithAvoirNonPaye = new Set();
            }
        });
    }

    loadStatsFacturesGlobales(): void {
        if (this.type !== 'facture') {
            this.statsFacturesGlobales = null;
            return;
        }
        this.documentService.getStatsFacturesGlobales(
            this.stationId > 0 ? this.stationId : undefined,
            this.userId > 0 ? this.userId : undefined
        ).subscribe({
            next: (res) => {
                if (res?.success && res?.data) {
                    this.statsFacturesGlobales = { data: res.data };
                } else {
                    this.statsFacturesGlobales = null;
                }
                this.cdr.detectChanges();
            },
            error: () => {
                this.statsFacturesGlobales = null;
                this.cdr.detectChanges();
            }
        });
    }

    get facturesAPayerTotalTTC(): number {
        const d = this.statsFacturesGlobales?.data?.factures_a_payer?.detail;
        if (!d) return 0;
        const nonPayees = d.factures_non_payees?.total_ttc ?? 0;
        const restant = d.montant_restant_factures_partiellement_payees?.montant_restant ?? 0;
        return nonPayees + restant;
    }

    loadStatsFacturesFournisseurGlobales(): void {
        if (this.type !== 'facture-fournisseur') {
            this.statsFacturesFournisseurGlobales = null;
            return;
        }
        this.documentService.getStatsFacturesFournisseurGlobales().subscribe({
            next: (res) => {
                if (res?.success && res?.data) {
                    this.statsFacturesFournisseurGlobales = { data: res.data };
                } else {
                    this.statsFacturesFournisseurGlobales = null;
                }
                this.cdr.detectChanges();
            },
            error: () => {
                this.statsFacturesFournisseurGlobales = null;
                this.cdr.detectChanges();
            }
        });
    }

    get facturesFournisseurAPayerTotalTTC(): number {
        const d = this.statsFacturesFournisseurGlobales?.data?.factures_a_payer?.detail;
        if (!d) return 0;
        const nonPayees = d.factures_non_payees?.total_ttc ?? 0;
        const restant = d.montant_restant_factures_partiellement_payees?.montant_restant ?? 0;
        return nonPayees + restant;
    }

    shouldShowPaiementIcon(item: any): boolean {
        const status = (item?.status ?? item?.fullData?.statut?.titre ?? item?.statut?.titre ?? '').toString().trim();
        if (this.type === 'avoir' || this.type === 'avoir-fournisseur') {
            return status === 'Non utilisé' || status === 'Partiellement utilisé';
        }
        if (this.type !== 'facture' && this.type !== 'facture-fournisseur' && this.type !== 'retour-fournisseur') {
            return false;
        }
        if (status === 'Payé' || status === 'Payée') return false;
        const id = item?.id ?? item?.fullData?.id;
        const statusAllowed = ['Partiellement payé', 'Non payé', 'Non utilisé', 'Partiellement utilisé'].includes(status);
        const hasAvoirNonPaye = id != null && this.factureIdsWithAvoirNonPaye.has(Number(id));
        return statusAllowed || hasAvoirNonPaye;
    }

    isConvertDisabled(item: any): boolean {
        if (this.type === 'avoir' || this.type === 'avoir-fournisseur') {
            return true;
        }
        const status = (item?.status ?? item?.fullData?.statut?.titre ?? item?.statut?.titre ?? '').toString().trim();
        const statutId = item?.statut_id ?? item?.fullData?.statut_id ?? item?.statut?.id;
        if (status === 'Brouillon' || Number(statutId) === 1) {
            return true;
        }
        if (this.type === 'facture' || this.type === 'facture-fournisseur' || this.type === 'retour-fournisseur') {
            const disabledByLabel = ['Utilisé', 'Non utilisé', 'Partiellement utilisé'].includes(status);
            const disabledById = [18, 19, 20].includes(Number(statutId));
            return disabledByLabel || disabledById;
        }
        return false;
    }

    openPaiementModal(item?: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        const facture = item || this.selectedItem;
        if (facture) {
            this.paiementFacture.openModal(facture, this.type);
        } else {
            this.toastr.error('Veuillez sélectionner une facture', 'Erreur');
        }
    }
    private lastAvoirUpdateAfterPaiement: { documentId: number, statutId: number, label?: string } | null = null;

    onPaiementSuccess(event: { paiement: any, documentId: number, avoirDocumentId?: number, avoirStatutId?: number, avoirStatutLabel?: string }): void {
        if (event.avoirDocumentId != null && event.avoirStatutId != null) {
            this.lastAvoirUpdateAfterPaiement = {
                documentId: event.avoirDocumentId,
                statutId: event.avoirStatutId,
                label: event.avoirStatutLabel ?? 'Utilisé'
            };
        }
        setTimeout(() => {
            this.refreshDataAfterPaiement();
        }, 1500);
    }

    private refreshDataAfterPaiement(): void {
        const normalizedStatus = this.normalizeStatus(this.status);
        this.reloadAchatDataByCurrentScope(normalizedStatus);
        if (this.type === 'facture') {
            this.dataService.loadByTypeAndStatus(this.type, 'Tous');
        } else if (this.type === 'facture-fournisseur' || this.type === 'retour-fournisseur') {
            this.achatService.loadByTypeAndStatus(this.type, 'Tous');
        }
        const dataObservable = this.getDataObservable();
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
        this.isLoading = true;
        this.cdr.detectChanges();
        
        this.dataSubscription = dataObservable.subscribe({
            next: (data) => {
                const filtered = this.applyTypeFilterForArchive(data || []);
                this.archiveData = this.deduplicateDocumentsById(filtered);
                this.updateFilteredData();
                if (this.lastAvoirUpdateAfterPaiement) {
                    const { documentId: avoirDocId, statutId, label: statutLabel } = this.lastAvoirUpdateAfterPaiement;
                    const label = statutLabel ?? (statutId === 20 ? 'Partiellement utilisé' : 'Utilisé');
                    const item = this.archiveData.find((it: any) => (it?.id ?? it?.fullData?.id) === avoirDocId);
                    if (item) {
                        const it = item as any;
                        const fullData = it.fullData || it;
                        fullData.statut_id = statutId;
                        if (fullData.statut && typeof fullData.statut === 'object') {
                            fullData.statut.titre = label;
                        }
                        it.statut_id = statutId;
                        it.status = label;
                        it.statut = it.statut && typeof it.statut === 'object' ? { ...it.statut, titre: label } : label;
                    }
                    this.lastAvoirUpdateAfterPaiement = null;
                    this.updateFilteredData();
                }
                this.calculateFactureTotals();
                if (this.type === 'facture' || this.type === 'facture-fournisseur' || this.type === 'retour-fournisseur') {
                    this.loadFactureIdsWithAvoirNonPaye();
                }
                this.isLoading = false;
                this.cdr.detectChanges();

            },
            error: (error) => {
                this.isLoading = false;
                this.cdr.detectChanges();
            }
        });
    }

    openModal(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur, type: string) {
        this.selectedItem = item;
        this.toastr.info(`Ouverture du modal pour ${type}`);
    }

    duplicateDocument(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur): void {
        const documentId = item.id;
        if (!documentId) {
            this.toastr.error('ID du document manquant pour la duplication');
            return;
        }

        this.isLoading = true;
        this.toastr.info('Chargement du document à dupliquer...', '', { timeOut: 2000 });
        this.documentService.getDocumentById(documentId).subscribe({
            next: (response) => {
                const doc = response?.data?.document || response?.data || response;
                if (!doc) {
                    this.toastr.error('Document introuvable');
                    this.isLoading = false;
                    return;
                }
                const addRoute = this.getAddRoute();
                this.router.navigate(addRoute, {
                    queryParams: {
                        duplicate: 'true',
                        sourceId: documentId
                    }
                });

                this.isLoading = false;
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du document à dupliquer');
                this.isLoading = false;
            }
        });
    }

    downloadPDF() {
        if (!this.table || this.paginatedData.length === 0) {
            this.toastr.error('Aucune donnée à télécharger ou table non trouvée.');
            return;
        }

        const tableElement = this.table.nativeElement;
        const date = todayLocalDateKey();
        const filename = `tableau_${this.type}_${date}.pdf`;
        const headerText = `Statut: ${this.status}, Période: ${this.selectedPeriod || '-'}`;

        const headerDiv = document.createElement('div');
        headerDiv.style.padding = '10px';
        headerDiv.style.fontSize = '14px';
        //headerDiv.style.fontWeight = 'bold';
        headerDiv.style.textAlign = 'center';
        headerDiv.innerText = headerText;
        document.body.appendChild(headerDiv);

        const originalOverflow = tableElement.style.overflow;
        tableElement.style.overflow = 'visible';

        Promise.all([
            html2canvas(headerDiv, {scale: 2, useCORS: true, backgroundColor: '#ffffff'}),
            html2canvas(tableElement, {scale: 2, useCORS: true, backgroundColor: '#ffffff'})
        ]).then(([headerCanvas, tableCanvas]) => {
            const headerImgData = headerCanvas.toDataURL('image/png');
            const tableImgData = tableCanvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 280;
            const pageHeight = 210;
            const headerImgHeight = (headerCanvas.height * imgWidth) / headerCanvas.width;
            const tableImgHeight = (tableCanvas.height * imgWidth) / tableCanvas.width;
            let position = 10;

            pdf.addImage(headerImgData, 'PNG', 10, position, imgWidth, headerImgHeight);
            position += headerImgHeight + 10;

            pdf.addImage(tableImgData, 'PNG', 10, position, imgWidth, tableImgHeight);
            let heightLeft = tableImgHeight - (pageHeight - position);

            while (heightLeft >= 0) {
                pdf.addPage();
                position = -heightLeft;
                pdf.addImage(tableImgData, 'PNG', 10, position, imgWidth, tableImgHeight);
                heightLeft -= pageHeight;
            }

            document.body.removeChild(headerDiv);
            tableElement.style.overflow = originalOverflow;

            pdf.save(filename);
            this.toastr.success('Tableau téléchargé en PDF avec succès.');
        }).catch(error => {
            this.toastr.error('Erreur lors de la génération du PDF.');
            document.body.removeChild(headerDiv);
            tableElement.style.overflow = originalOverflow;
        });
    }

    openPDFInNewWindow() {
        if (!this.table || this.paginatedData.length === 0) {
            this.toastr.error('Aucune donnée à afficher ou table non trouvée.');
            return;
        }

        const tableElement = this.table.nativeElement;
        const headerText = `Statut: ${this.status}, Période: ${this.selectedPeriod || 'N/A'}`;

        const headerDiv = document.createElement('div');
        headerDiv.style.padding = '10px';
        headerDiv.style.fontSize = '14px';
        headerDiv.style.fontWeight = 'bold';
        headerDiv.style.textAlign = 'center';
        headerDiv.innerText = headerText;
        document.body.appendChild(headerDiv);

        const originalOverflow = tableElement.style.overflow;
        tableElement.style.overflow = 'visible';

        Promise.all([
            html2canvas(headerDiv, {scale: 2, useCORS: true, backgroundColor: '#ffffff'}),
            html2canvas(tableElement, {scale: 2, useCORS: true, backgroundColor: '#ffffff'})
        ]).then(([headerCanvas, tableCanvas]) => {
            const headerImgData = headerCanvas.toDataURL('image/png');
            const tableImgData = tableCanvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 280;
            const pageHeight = 210;
            const headerImgHeight = (headerCanvas.height * imgWidth) / headerCanvas.width;
            const tableImgHeight = (tableCanvas.height * imgWidth) / tableCanvas.width;
            let position = 10;

            pdf.addImage(headerImgData, 'PNG', 10, position, imgWidth, headerImgHeight);
            position += headerImgHeight + 10;

            pdf.addImage(tableImgData, 'PNG', 10, position, imgWidth, tableImgHeight);
            let heightLeft = tableImgHeight - (pageHeight - position);

            while (heightLeft >= 0) {
                pdf.addPage();
                position = -heightLeft;
                pdf.addImage(tableImgData, 'PNG', 10, position, imgWidth, tableImgHeight);
                heightLeft -= pageHeight;
            }

            document.body.removeChild(headerDiv);
            tableElement.style.overflow = originalOverflow;

            const pdfUrl = pdf.output('bloburl');
            window.open(pdfUrl, '_blank');
            this.toastr.success('PDF ouvert dans une nouvelle fenêtre.');
        }).catch(error => {
            this.toastr.error('Erreur lors de l\'affichage du PDF.');
            document.body.removeChild(headerDiv);
            tableElement.style.overflow = originalOverflow;
        });
    }

    private getDateFilterMethod() {
        switch (this.type) {
            case 'devis':
                return this.dataService.filterQuotesByDateRange;
            case 'commande-client':
                return this.dataService.filterOrdersByDateRange;
            case 'facture':
                return this.dataService.filterFactureByDateRange;
            case 'avoir':
                return this.dataService.filterAvoirByDateRange;
            case 'bon-livraison':
                return this.dataService.filterBonLivraisonByDateRange;
            case 'bon-sortie':
                return this.dataService.filterBonSortieByDateRange;
            case 'commande-fournisseur':
                return this.achatService.filterCommandeFournisseurByDateRange;
            case 'bon-reception':
                return this.achatService.filterBonReceptionByDateRange;
            case 'facture-fournisseur':
                return this.achatService.filterFactureFournisseurByDateRange;
            case 'retour-fournisseur':
                return this.achatService.filterRetourFournisseurByDateRange;
            case 'avoir-fournisseur':
                return this.achatService.filterAvoirFournisseurByDateRange;
            default:
                return this.dataService.filterQuotesByDateRange;
        }
    }

    private getStatusFilterMethod() {
        switch (this.type) {
            case 'devis':
                return this.dataService.filterQuotesByStatus;
            case 'commande-client':
                return this.dataService.filterOrdersByStatus;
            case 'facture':
                return this.dataService.filterFactureByStatus;
            case 'avoir':
                return this.dataService.filterAvoirByStatus;
            case 'bon-livraison':
                return this.dataService.filterBonLivraisonByStatus;
            case 'bon-sortie':
                return this.dataService.filterBonSortieByStatus;
            case 'commande-fournisseur':
                return this.achatService.filterCommandeFournisseurByStatus;
            case 'bon-reception':
                return this.achatService.filterBonReceptionByStatus;
            case 'facture-fournisseur':
                return this.achatService.filterFactureFournisseurByStatus;
            case 'retour-fournisseur':
                return this.achatService.filterRetourFournisseurByStatus;
            case 'avoir-fournisseur':
                return this.achatService.filterAvoirFournisseurByStatus;
            default:
                return this.dataService.filterQuotesByStatus;
        }
    }

    getBaseRoute(): string {
        const currentUrl = this.router.url;
        if (currentUrl.includes('/stock') || this.type === 'inventaire' || this.type === 'bon-transfert') {
            return '/stock';
        }
        if (currentUrl.includes('/tiers/clients')) {
            return currentUrl.includes('/vente-negoce') ? '/vente-negoce' : '/vente';
        }
        if (currentUrl.includes('/vente-negoce')) {
            return '/vente-negoce';
        }
        return currentUrl.includes('/vente') ? '/vente' : '/achat';
    }

    private initClientDetailsDocumentScope(): void {
        const url = this.router.url;
        if (!url.includes('/tiers/clients/details/') && !url.includes('/bibliotheque-clients/details/')) {
            return;
        }
        const ref = this.getRouteParamClientReference();
        if (!ref) {
            return;
        }
        const refStr = String(ref).trim();
        if (/^\d+$/.test(refStr)) {
            const id = parseInt(refStr, 10);
            this.clientDetailsScopeClientId = id;
            return;
        }
        this.clientDetailsScopeResolveSub = this.clientService.getClientById(ref).pipe(first()).subscribe({
            next: (c) => {
                if (c?.id != null) {
                    this.clientDetailsScopeClientId = c.id;
                    this.updateFilteredData();
                    this.calculateFactureTotals();
                    this.cdr.detectChanges();
                }
            },
            error: () => {}
        });
    }

    private getRouteParamClientReference(): string | null {
        let route: ActivatedRoute | null = this.route;
        while (route) {
            const ref = route.snapshot.paramMap.get('reference');
            if (ref) {
                return ref;
            }
            route = route.parent;
        }
        return null;
    }

    getAddRoute(): string[] {
        if (this.type === 'inventaire') {
            return ['/inventaire', 'ajout-inventaire'];
        }
        if (this.type === 'bon-transfert') {
            return ['/bon-transfert', 'ajout-bonTransfert'];
        }
        if (this.type === 'avoir') {
            return ['/vente', 'facture', 'add-facture'];
        }
        if (this.type === 'avoir-fournisseur') {
            return ['/achat', 'facture-fournisseur', 'add-facture-fournisseur'];
        }
        if (this.type === 'retour-fournisseur') {
            return ['/achat', 'retour-fournisseur', 'add-retour-fournisseur'];
        }
        const type: string = this.type || 'devis';
        const baseRoute: string = this.getBaseRoute();
        return [baseRoute, type, 'add-' + type];
    }

    updateBaseRoute(): void {
        this.baseRoute = this.getBaseRoute();
    }

    async downloadApercuPDF(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        if (!this.apercueModal) {
            this.toastr.error('Composant d\'aperçu non disponible.');
            return;
        }

        try {
            this.isExportingPDF = true;
            this.toastr.info('Préparation de l\'aperçu pour le PDF...');

            this.selectedItem = item;

            this.isApercuVisible = true;

            await new Promise(resolve => setTimeout(resolve, 100));

            this.cdr.detectChanges();

            await new Promise(resolve => setTimeout(resolve, 300));

            if (!this.apercueModal) {
                throw new Error('Composant apercuModal non disponible après rendu');
            }
            this.apercueModal.openSettingsPanel();

            await new Promise(resolve => setTimeout(resolve, 200));
            this.cdr.detectChanges();

            await new Promise(resolve => setTimeout(resolve, 500));

            if (!this.apercueModal.documentContainer) {
                throw new Error('documentContainer non disponible dans apercuModal');
            }

            this.toastr.info('Génération du PDF en cours...');
            await this.apercueModal.downloadPDF();

        } catch (error) {
            this.toastr.error(`Erreur lors du téléchargement du PDF: ${error.message || 'Erreur inconnue'}`);
        } finally {
            this.isExportingPDF = false;
            this.isApercuVisible = false;
            if (this.apercueModal) {
                this.apercueModal.closeSettingsPanel();
            }
            this.cdr.detectChanges();
        }
    }

    async downloadApproveVentePDF(item: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur): Promise<void> {
        const documentId = item.id;
        if (!documentId) {
            this.toastr.error('ID du document manquant pour le téléchargement PDF.');
            return;
        }

        this.isExportingPDF = true;

        try {
            if (!this.stationId) {
                this.loadUserData();
            }
            if (!this.stationData && this.stationId) {
                await new Promise<void>((resolve) => {
                    this.stationService.getStation(this.stationId).subscribe({
                        next: (response) => {
                            if (response && response.success && response.station) {
                                this.stationData = response.station;
                                if (this.stationData.coordonnees && Array.isArray(this.stationData.coordonnees) && this.stationData.coordonnees.length > 0) {
                                    console.log('📋 [downloadApproveVentePDF] Première coordonnée:', this.stationData.coordonnees[0]);
                                    console.log('📋 [downloadApproveVentePDF] Téléphones de la coordonnée:', this.stationData.coordonnees[0].telephones);
                                } else {
                                    console.warn('⚠️ [downloadApproveVentePDF] Coordonnées vides ou non-array:', this.stationData.coordonnees);
                                }
                                console.log('📋 [downloadApproveVentePDF] Téléphones de la station:', this.stationData.telephones);
                            } else {
                                console.warn('⚠️ [downloadApproveVentePDF] Format de réponse inattendu:', response);
                            }
                            resolve();
                        },
                        error: (error) => {
                            resolve();
                        }
                    });
                });
            } else if (this.stationData) {
                if (!this.stationData.coordonnees || !Array.isArray(this.stationData.coordonnees) || this.stationData.coordonnees.length === 0) {

                    await new Promise<void>((resolve) => {
                        this.stationService.getStation(this.stationId).subscribe({
                            next: (response) => {
                                if (response && response.success && response.station) {
                                    this.stationData = response.station;
                                }
                                resolve();
                            },
                            error: () => resolve()
                        });
                    });
                }
            }

            const response = await this.documentService.getDocumentById(documentId).pipe(first()).toPromise();
            const doc = response?.data?.document || response?.data || response;

            if (!doc) {
                this.toastr.error('Document introuvable pour le téléchargement PDF.');
                this.isExportingPDF = false;
                return;
            }
            /** Même largeur logique que la page PDF paysage (297 mm) pour éviter l’étirement du canvas → texte énorme. */
            const tempContainer = document.createElement('div');
            tempContainer.style.position = 'absolute';
            tempContainer.style.left = '-9999px';
            tempContainer.style.boxSizing = 'border-box';
            tempContainer.style.width = '297mm';
            tempContainer.style.maxWidth = '297mm';
            tempContainer.style.padding = '46px';
            tempContainer.style.backgroundColor = '#ffffff';
            tempContainer.style.fontFamily = 'Arial, Helvetica, sans-serif';
            tempContainer.style.fontSize = '11px';
            tempContainer.style.lineHeight = '1.35';
            tempContainer.style.color = 'rgba(47, 43, 61, 0.92)';
            document.body.appendChild(tempContainer);
            if (this.stationData) {
                if (this.stationData.coordonnees && this.stationData.coordonnees.length > 0) {
                    console.log('🔍 [downloadApproveVentePDF] Première coordonnée:', this.stationData.coordonnees[0]);
                }
            }
            const htmlContent = this.generateDocumentHTML(doc);
            if (htmlContent.includes('Coordonnées')) {
                const coordonneesIndex = htmlContent.indexOf('Coordonnées');
                const coordonneesSection = htmlContent.substring(coordonneesIndex, Math.min(coordonneesIndex + 800, htmlContent.length));

                if (this.stationData && this.stationData.coordonnees && this.stationData.coordonnees.length > 0) {
                    const coord = this.stationData.coordonnees[0];
                    const nomComplet = `${coord.prenom || ''} ${coord.nom || ''}`.trim();
                }
            } else {
                console.warn('⚠️ [downloadApproveVentePDF] Le mot "Coordonnées" n\'est pas trouvé dans le HTML généré!');
            }
            tempContainer.innerHTML = htmlContent;
            await new Promise(resolve => setTimeout(resolve, 500));
            const canvas = await html2canvas(tempContainer, getHtml2CanvasOptionsForDocumentExport(tempContainer));
            document.body.removeChild(tempContainer);
            const documentType = doc.typeDocument?.titre || doc.type_document?.titre || 'Document';
            const documentRef = doc.ref_externe || doc.reference || 'INV-000001';
            const date = todayLocalDateKey();
            const cleanDocumentType = documentType.toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/[^a-z0-9-]/g, '');
            const cleanDocumentRef = documentRef
                .replace(/[^a-zA-Z0-9]/g, '')
                .substring(0, 20);
            const filename = `${cleanDocumentType}-${cleanDocumentRef}-${date}.pdf`;
            saveCanvasAsPdfDocument(canvas, filename);
            this.toastr.success(`PDF "${documentType} ${documentRef}" téléchargé avec succès !`, 'Succès');

        } catch (error: any) {
            this.toastr.error(`Erreur lors de la génération du PDF: ${error?.message || 'Erreur inconnue'}`, 'Erreur');
        } finally {
            this.isExportingPDF = false;
            this.cdr.detectChanges();
        }
    }

    private generateDocumentHTML(doc: any): string {
        const stationData = this.stationData;
        const stationBrandName = resolveEnterpriseDisplayName(
            stationData && (stationData.nom_entreprise || stationData.nom || stationData.raison_sociale || stationData.nom_station || stationData.libelle || stationData.label)
        );
        const isAchat = ['COMMANDE FOURNISSEUR', 'BON RECEPTION', 'FACTURE FOURNISSEUR'].includes(doc.typeDocument?.titre || doc.type_document?.titre || '');
        const party = isAchat ? (doc.fournisseur_data || doc.fornisseurs?.[0]) : (doc.client_data || doc.clients?.[0]);
        const partyEmail = party?.email || '--';
        const partyPhone = party?.telephone || party?.phone || '--';
        let coordonneesHTML = '';
        
        if (stationData && stationData.coordonnees && stationData.coordonnees.length > 0) {
            const coordonnees = stationData.coordonnees[0];
            const prenom = coordonnees.prenom || '';
            const nom = coordonnees.nom || '';
            const email = coordonnees.email || '--';

            let telephone = '--';
            if (coordonnees.telephones && coordonnees.telephones.length > 0) {
                telephone = coordonnees.telephones[0].numero || '--';
            } else if (stationData.telephones && stationData.telephones.length > 0) {
                telephone = stationData.telephones[0].numero || '--';
            }
            
            const nomComplet = `${prenom} ${nom}`.trim() || '--';

            
            coordonneesHTML = `
                <p style="font-size: 10px; margin: 0 0 4px 0;">${nomComplet}</p>
                <p style="font-size: 10px; margin: 0 0 4px 0;">${email}</p>
                <p style="font-size: 10px; margin: 0;">${telephone}</p>
            `;

        } else {
            coordonneesHTML = `
                <p style="font-size: 10px; margin: 0 0 4px 0;">${partyPhone}</p>
                <p style="font-size: 10px; margin: 0;">${partyEmail}</p>
            `;
        }

        
        const typeDocument = doc.typeDocument?.titre || doc.type_document?.titre || 'Document';
        const refExterne = doc.ref_externe || doc.reference || 'INV-000001';
        const date = doc.date ? new Date(doc.date).toLocaleDateString('fr-TN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }) : '--';
        const dateLivraison = doc.date_livraison ? new Date(doc.date_livraison).toLocaleDateString('fr-TN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }) : '--';
        const partyName = isAchat
            ? (party?.nom_entreprise || '--')
            : (party?.nom_client || party?.nom_prenom || '--');
        const partyIdFiscal = isAchat
            ? (party?.numero_identification_fiscale || '--')
            : (party?.identifiant_unique || '--');
        const partyNumeroIdentification = party?.numero_identification_fiscale || '--';
        const partyAddress = party?.adresse || '--';
        const responsable = party?.responsable || '--';

        // Entreprise
        const entreprise = doc.entreprises?.[0] || {};
        const entrepriseNom = entreprise.nom_entreprise || 'Shopi';
        const entrepriseAdresse = entreprise.adresse || 'Adresse non définie';
        const entrepriseVille = entreprise.ville || '';
        const entreprisePays = entreprise.pays || '';
        const entrepriseMatricule = entreprise.matricule_fiscale || '--';

        // Banque
        const banque = doc.coordonneesBancaires?.[0] || {};
        const banqueNom = banque.banque || banque.nom || 'Banque non définie';
        const banqueRIB = banque.rib || '--';

        // Lignes document
        const lignes = doc.lignesDocument || doc.lignes_document || [];

        // Calcul des totaux
        const totalHT = lignes.reduce((sum: number, l: any) => {
            const prix = parseFloat(l.prix_ht) || 0;
            const qnt = parseFloat(l.qnt) || 0;
            return sum + (prix * qnt);
        }, 0);

        const totalTVA = lignes.reduce((sum: number, l: any) => {
            const prix = parseFloat(l.prix_ht) || 0;
            const qnt = parseFloat(l.qnt) || 0;
            const tva = parseFloat(l.tva) || 0;
            return sum + (prix * qnt * tva / 100);
        }, 0);

        const totalTTC = totalHT + totalTVA;
        const timbreFiscal = typeDocument.includes('FACTURE') ? 1.0 : 0.6;
        const netAPayer = totalTTC + timbreFiscal;

        // Résumé TVA
        const tvaMap = new Map<string, { base: number; amount: number }>();
        lignes.forEach((l: any) => {
            const tva = parseFloat(l.tva) || 0;
            const rate = tva.toString();
            const prix = parseFloat(l.prix_ht) || 0;
            const qnt = parseFloat(l.qnt) || 0;
            const base = prix * qnt;
            const amount = base * tva / 100;

            if (tvaMap.has(rate)) {
                const prev = tvaMap.get(rate)!;
                tvaMap.set(rate, { base: prev.base + base, amount: prev.amount + amount });
            } else {
                tvaMap.set(rate, { base, amount });
            }
        });

        const tvaSummary = Array.from(tvaMap.entries()).map(([rate, { base, amount }]) => ({
            rate,
            base: parseFloat(base.toFixed(3)),
            amount: parseFloat(amount.toFixed(3))
        }));

        // Projet
        const projet = doc.projets?.[0];
        // id_projet est maintenant un string numérique (ex: "7") au lieu de "PROJ-0007"
        const projetIdDisplay = projet?.id_projet || projet?.id || projet?.projet_id || '--';
        const projetDisplay = projet ? `${projetIdDisplay} - ${projet.titre || projet.libelle || 'Projet inconnu'}` : '--';

        // Entrepôt
        const entrepot = doc.entrepot?.nom || '--';

        // Catégories
        const categories = doc.categories?.map((c: any) => c.nom || c.titre).join(', ') || '--';

        // Champs cachés (peuvent être des objets ou des chaînes JSON)
        let hiddenClientFields: any = {};
        if (doc.hidden_client_fields) {
            if (typeof doc.hidden_client_fields === 'string') {
                try {
                    hiddenClientFields = JSON.parse(doc.hidden_client_fields);
                } catch (e) {
                    hiddenClientFields = {};
                }
            } else {
                hiddenClientFields = doc.hidden_client_fields;
            }
        }

        let hiddenFournisseurFields: any = {};
        if (doc.hidden_fournisseur_fields) {
            if (typeof doc.hidden_fournisseur_fields === 'string') {
                try {
                    hiddenFournisseurFields = JSON.parse(doc.hidden_fournisseur_fields);
                } catch (e) {
                    hiddenFournisseurFields = {};
                }
            } else {
                hiddenFournisseurFields = doc.hidden_fournisseur_fields;
            }
        }
        let html = `
            <div style="display: flex; flex-direction: column; min-height: 195mm; width: 100%; box-sizing: border-box; padding: 0; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.35; color: rgba(47, 43, 61, 0.92);">
                <div style="flex: 1 1 auto; width: 100%; min-height: 0;">
                <!-- En-tête (échelle proche de l’aperçu approve-vente) -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
                    <div style="display: flex; align-items: center;">
                        <p style="font-size: 16px; color: #2F2B3DE5; margin: 0; font-weight: 600;">${stationBrandName}</p>
                    </div>
                    <div>
                        <strong style="font-size: 14px; font-weight: 600;">${typeDocument} / </strong>
                        <span style="font-size: 14px; color: #6c757d;">${refExterne}</span>
                    </div>
                </div>

                <!-- Client/Fournisseur + Détails -->
                <div style="display: flex; justify-content: space-between; margin-top: 12px; gap: 16px;">
                    <!-- ${isAchat ? 'Fournisseur' : 'Client'} -->
                    <div style="flex: 1; min-width: 0;">
                        <p style="font-size: 12px; color: #2F2B3DE5; font-weight: 700; margin: 0 0 6px 0;">${isAchat ? 'Fournisseur' : 'Client'}</p>
                        <hr style="border: none; border-bottom: 1px solid #134AD3; margin: 6px 0 8px 0;">
                        
                        ${!isAchat ? `
                            ${!hiddenClientFields.nomClient ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Nom</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyName}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenClientFields.identifiant ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Identifiant unique</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyIdFiscal}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenClientFields.adresse ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Adresse</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyAddress}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenClientFields.email ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Email</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyEmail}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenClientFields.numeroIdentification ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Numéro d'identification fiscale</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyNumeroIdentification}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                        ` : `
                            ${!hiddenFournisseurFields.nomEntreprise ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Entreprise</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyName}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenFournisseurFields.numeroIdentification ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Numéro d'identification fiscale</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyIdFiscal}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenFournisseurFields.responsable ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Responsable</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${responsable}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenFournisseurFields.telephone ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Téléphone</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyPhone}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                            ${!hiddenFournisseurFields.adresse ? `
                                <div style="margin: 4px 0;">
                                    <table style="font-size: 11px;">
                                        <tr>
                                            <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Adresse</label></td>
                                            <td><label style="font-size: 11px; font-weight: 400;">${partyAddress}</label></td>
                                        </tr>
                                    </table>
                                </div>
                                <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                            ` : ''}
                        `}
                    </div>

                    <!-- Détails du document -->
                    <div style="flex: 1; min-width: 0; margin-left: 12px;">
                        <p style="font-size: 12px; color: #2F2B3DE5; font-weight: 700; margin: 0 0 6px 0;">Détails du document</p>
                        <hr style="border: none; border-bottom: 1px solid #134AD3; margin: 6px 0 8px 0;">
                        
                        ${isAchat ? `
                            <div style="margin: 4px 0;">
                                <table style="font-size: 11px;">
                                    <tr>
                                        <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Référence externe</label></td>
                                        <td><label style="font-size: 11px; font-weight: 700;">${refExterne}</label></td>
                                    </tr>
                                </table>
                            </div>
                            <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                        ` : ''}
                        
                        <div style="margin: 4px 0;">
                            <table style="font-size: 11px;">
                                <tr>
                                    <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Date</label></td>
                                    <td><label style="font-size: 11px; font-weight: 400;">${date}</label></td>
                                </tr>
                            </table>
                        </div>
                        <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                        
                        ${['COMMANDE CLIENT', 'COMMANDE FOURNISSEUR'].includes(typeDocument) ? `
                            <div style="margin: 4px 0;">
                                <table style="font-size: 11px;">
                                    <tr>
                                        <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Date de livraison</label></td>
                                        <td><label style="font-size: 11px; font-weight: 400;">${dateLivraison}</label></td>
                                    </tr>
                                </table>
                            </div>
                            <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                        ` : ''}
                        
                        ${['BON DE LIVRAISON', 'FACTURE', 'BON RECEPTION', 'FACTURE FOURNISSEUR'].includes(typeDocument) ? `
                            <div style="margin: 4px 0;">
                                <table style="font-size: 11px;">
                                    <tr>
                                        <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Entrepôt</label></td>
                                        <td><label style="font-size: 11px; font-weight: 400;">${entrepot}</label></td>
                                    </tr>
                                </table>
                            </div>
                            <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                        ` : ''}
                        
                        <div style="margin: 4px 0;">
                            <table style="font-size: 11px;">
                                <tr>
                                    <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Projet</label></td>
                                    <td><label style="font-size: 11px; font-weight: 400;">${projetDisplay}</label></td>
                                </tr>
                            </table>
                        </div>
                        <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                        
                        ${isAchat ? `
                            <div style="margin: 4px 0;">
                                <table style="font-size: 11px;">
                                    <tr>
                                        <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Catégories</label></td>
                                        <td><label style="font-size: 11px; font-weight: 400;">${categories}</label></td>
                                    </tr>
                                </table>
                            </div>
                            <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                        ` : ''}
                        
                        <div style="margin: 4px 0;">
                            <table style="font-size: 11px;">
                                <tr>
                                    <td style="width: 130px; vertical-align: top;"><label style="font-size: 11px; font-weight: 600;">Note</label></td>
                                    <td><label style="font-size: 11px; font-weight: 400;">${doc.note || '--'}</label></td>
                                </tr>
                            </table>
                        </div>
                        <hr style="border: none; border-bottom: 1px solid #e5e7eb; margin: 6px 0;">
                    </div>
                </div>

                <!-- Produits -->
                <div style="margin-top: 14px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                        <thead style="background-color: rgba(19, 74, 211, 0.16);">
                            <tr>
                                <th style="text-align: left; padding: 6px 8px; border: 1px solid #dee2e6; font-size: 10px; font-weight: 600;">DÉSIGNATION</th>
                                <th style="text-align: left; padding: 6px 8px; border: 1px solid #dee2e6; font-size: 10px; font-weight: 600;">QUANTITÉ</th>
                                <th style="text-align: left; padding: 6px 8px; border: 1px solid #dee2e6; font-size: 10px; font-weight: 600;">QUANTITÉ DISPONIBLE</th>
                                <th style="text-align: left; padding: 6px 8px; border: 1px solid #dee2e6; font-size: 10px; font-weight: 600;">VALEUR UNITAIRE</th>
                                <th style="text-align: left; padding: 6px 8px; border: 1px solid #dee2e6; font-size: 10px; font-weight: 600;">TOTAL HT</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${lignes.map((ligne: any) => `
                                <tr>
                                    <td style="padding: 5px 8px; border: 1px solid #dee2e6; font-size: 10px;">${ligne.libelle || '--'}</td>
                                    <td style="padding: 5px 8px; border: 1px solid #dee2e6; font-size: 10px;">${ligne.qnt || 0}</td>
                                    <td style="padding: 5px 8px; border: 1px solid #dee2e6; font-size: 10px;">--</td>
                                    <td style="padding: 5px 8px; border: 1px solid #dee2e6; font-size: 10px;">${(parseFloat(ligne.prix_ht) || 0).toFixed(3)} TND</td>
                                    <td style="padding: 5px 8px; border: 1px solid #dee2e6; font-size: 10px;">${((parseFloat(ligne.prix_ht) || 0) * (parseFloat(ligne.qnt) || 0)).toFixed(3)} TND</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>

                <!-- TVA (centré) + Totaux (droite) -->
                <div style="position: relative; width: 100%; margin-top: 14px; min-height: 72px;">
                    <div style="display: flex; justify-content: center; width: 100%;">
                        <table style="border-collapse: collapse; font-size: 10px; margin: 0 auto;">
                            <thead style="background-color: rgba(19, 74, 211, 0.16);">
                                <tr>
                                    <th style="text-align: center; padding: 5px 8px; border: 1px solid #dee2e6;">TVA</th>
                                    <th style="text-align: center; padding: 5px 8px; border: 1px solid #dee2e6;">BASE</th>
                                    <th style="text-align: center; padding: 5px 8px; border: 1px solid #dee2e6;">MONTANT</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${tvaSummary.map((tva: any) => `
                                    <tr>
                                        <td style="padding: 5px 8px; border: 1px solid #dee2e6; text-align: center;">${tva.rate}%</td>
                                        <td style="padding: 5px 8px; border: 1px solid #dee2e6; text-align: center;">${tva.base.toFixed(3)} TND</td>
                                        <td style="padding: 5px 8px; border: 1px solid #dee2e6; text-align: center;">${tva.amount.toFixed(3)} TND</td>
                                    </tr>
                                `).join('')}
                            </tbody>
                        </table>
                    </div>

                    <!-- Totaux -->
                    <div style="position: absolute; top: 0; right: 0; min-width: 200px;">
                        <table style="width: 100%; border-collapse: collapse; border: 1px solid rgba(47, 43, 61, 0.14); border-top: 2px solid rgba(19, 74, 211, 1); font-size: 10px;">
                            <tbody>
                                <tr style="border-bottom: 1px solid #2F2B3D1F;">
                                    <td style="padding: 5px 8px;">Total HT</td>
                                    <td style="padding: 5px 8px; text-align: right;">${totalHT.toFixed(3)} TND</td>
                                </tr>
                                <tr style="border-bottom: 1px solid #2F2B3D1F;">
                                    <td style="padding: 5px 8px;">Total TVA</td>
                                    <td style="padding: 5px 8px; text-align: right;">${totalTVA.toFixed(3)} TND</td>
                                </tr>
                                <tr style="border-bottom: 1px solid #2F2B3D1F;">
                                    <td style="padding: 5px 8px;">Total TTC</td>
                                    <td style="padding: 5px 8px; text-align: right;">${totalTTC.toFixed(3)} TND</td>
                                </tr>
                                <tr style="border-bottom: 1px solid #2F2B3D1F;">
                                    <td style="padding: 5px 8px;">Timbre fiscal</td>
                                    <td style="padding: 5px 8px; text-align: right;">${timbreFiscal.toFixed(3)} TND</td>
                                </tr>
                                <tr style="font-weight: bold;">
                                    <td style="padding: 5px 8px;">Net à payer</td>
                                    <td style="padding: 5px 8px; text-align: right;">${netAPayer.toFixed(3)} TND</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>

                <!-- Footer : bas de « page », une seule ligne sur toute la largeur -->
                <div style="flex: 0 0 auto; width: 100%; margin-top: auto; padding-top: 14px; border-top: 1px solid #dee2e6; box-sizing: border-box;">
                    <div style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: flex-start; width: 100%; gap: 16px; font-size: 10px;">
                        <div style="flex: 1 1 0; min-width: 0; max-width: 33.33%;">
                            <p style="font-size: 11px; font-weight: bold; margin: 0 0 4px 0;">Entreprise</p>
                            <p style="font-size: 10px; margin: 0 0 2px 0;">${entrepriseNom}</p>
                            <p style="font-size: 10px; margin: 0 0 2px 0;">${entrepriseAdresse}</p>
                            <p style="font-size: 10px; margin: 0 0 2px 0;">${entrepriseVille} ${entreprisePays}</p>
                            <p style="font-size: 10px; margin: 0;">Matricule fiscal: ${entrepriseMatricule}</p>
                        </div>
                        <div style="flex: 1 1 0; min-width: 0; max-width: 33.33%;">
                            <p style="font-size: 11px; font-weight: bold; margin: 0 0 4px 0;">Coordonnées</p>
                            ${coordonneesHTML}
                        </div>
                        <div style="flex: 1 1 0; min-width: 0; max-width: 33.33%;">
                            <p style="font-size: 11px; font-weight: bold; margin: 0 0 4px 0;">Coordonnées bancaires</p>
                            <p style="font-size: 10px; margin: 0 0 2px 0;">${banqueNom}</p>
                            <p style="font-size: 10px; margin: 0;">${banqueRIB}</p>
                        </div>
                    </div>
                </div>
            </div>
        `;

        return html;
    }

    openEmailModal(item?: Quote | ClientOrder | Facture | BonLivraison | BonSortie | CommandeFournisseur) {
        // Définir l'item sélectionné pour l'email
        this.selectedItemForEmail = item || this.selectedItem;
        
        if (!this.selectedItemForEmail) {
            this.toastr.error('Veuillez sélectionner un document pour envoyer un email', 'Erreur');
            return;
        }
        
        if (this.emailComposeComponent) {
            this.emailComposeComponent.openModal();
        } else {
            this.toastr.error('Composant email non disponible', 'Erreur');
        }
    }

    getEmailReference(): string {
        if (!this.selectedItemForEmail) return 'N/A';
        return this.selectedItemForEmail.reference || 'N/A';
    }


    getEmailDate(): string {
        if (!this.selectedItemForEmail) return '';
        return this.selectedItemForEmail.date || '';
    }

    getEmailTotal(): string {
        if (!this.selectedItemForEmail) return '0.000 TND';
        const revenue = this.selectedItemForEmail.revenue || '0 TND';
        if (typeof revenue === 'string' && revenue.includes('TND')) {
            return revenue;
        }
        const total = parseFloat(String(revenue).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
        return `${total.toFixed(3)} TND`;
    }

    private loadExpandedDocument(id: number): void {
        this.isLoadingExpanded = true;
        this.expandedDocument = null;

        this.documentService.getDocumentById(id).subscribe({
            next: (doc) => {
                this.expandedDocument = doc;
                this.isLoadingExpanded = false;
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.isLoadingExpanded = false;
                this.toastr.error('Erreur lors du chargement du document');
                this.expandedRowId = null;
                this.cdr.detectChanges();
            }
        });
    }

    toggleExpandRow(item: any) {
        if (this.expandedRowId === item.id) {
            this.expandedRowId = null;
            this.expandedDocument = null;
            return;
        }

        this.expandedRowId = item.id;
        this.isLoadingExpanded = true;

        this.documentService.getDocumentById(item.id).subscribe({
            next: (res) => {
                this.expandedDocument = res.data.document || res.data;
                this.isLoadingExpanded = false;
                this.cdr.detectChanges();
            },
            error: () => {
                this.toastr.error('Erreur chargement détail');
                this.expandedRowId = null;
                this.isLoadingExpanded = false;
            }
        });
    }

    getItemId(item: any): number {
        return item.id;
    }

    calculateTotalHT(doc: any): number {
        return doc?.lignes_document?.reduce((sum: number, l: any) => sum + (l.qnt * l.prix_ht), 0) || 0;
    }

    calculateTotalTTC(doc: any): number {
        const ht = this.calculateTotalHT(doc);
        const tva = doc?.lignes_document?.reduce((sum: number, l: any) => sum + (l.qnt * l.prix_ht * l.tva / 100), 0) || 0;
        return ht + tva;
    }

    getStatusBadgeClass(status: string): any {
        return {
            'badge': true,
            'badge-tous': status === 'Tous',
            'badge-brouillon': status === 'Brouillon',
            'badge-cree': status === 'Crée',
            'badge-annule': status === 'Annulé',
            'badge-valide': status === 'Valide',
            'badge-livré': status === 'Livré',
            'badge-paye': status === 'Payé' || status === 'Payée',
            'badge-nonPaye': status === 'Non payé',
        };
    }

    private shouldRedirectToApprove(status: string): boolean {
        if (!status) return false;
        const statusesForApprove = [
            'Créé', 'Crée', 'Annulé', 'Négociation', 'Negociation',
            'Accepté', 'Accepte', 'Payé', 'Paye', 'Non payé', 'Non Payé', 'Non paye',
            'Partiellement payé', 'Partiellement paye',
            'Valide', 'Livré', 'Livre', 'Fermé', 'Ferme', 'Reçu', 'Recu'
        ];

        const normalizedStatus = this.normalizeStatus(status);
        return statusesForApprove.includes(normalizedStatus) || statusesForApprove.includes(status);
    }

    /**
     * Bon de transfert au statut final « Transféré » : ouvrir approve-vente (/action/validation), pas l’éditeur document.
     */
    private isBonTransfertStatutTransfere(status: string): boolean {
        if (!status) return false;
        const t = status
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        return t === 'transfere';
    }

    editDocument(item: any): void {
        const id = item.id;
        if (!id) {
            this.toastr.error('ID du document manquant');
            return;
        }
        const documentStatus = item.status ||
            item.statut?.titre ||
            item.fullData?.statut?.titre ||
            item.fullData?.status ||
            '';
        if (this.type === 'avoir') {
            this.router.navigate(['/vente', 'avoir', 'action', 'validation'], {
                queryParams: { id }
            });
            return;
        }
        if (this.type === 'inventaire') {
            if (this.shouldRedirectToApprove(documentStatus)) {
                this.router.navigate(['/inventaire', 'action', 'validation'], {
                    queryParams: {id}
                });
            } else {
                this.router.navigate(['/inventaire', 'ajout-inventaire'], {
                    queryParams: {id}
                });
            }
            return;
        }
        
        if (this.type === 'bon-transfert') {
            if (
                this.shouldRedirectToApprove(documentStatus) ||
                this.isBonTransfertStatutTransfere(documentStatus)
            ) {
                this.router.navigate(['/bon-transfert', 'action', 'validation'], {
                    queryParams: {id}
                });
            } else {
                this.router.navigate(['/bon-transfert', 'ajout-bonTransfert'], {
                    queryParams: {id}
                });
            }
            return;
        }
        if (this.shouldRedirectToApprove(documentStatus)) {
            const basePath = this.getBaseRoute();
            this.router.navigate([basePath, this.type, 'action', 'validation'], {
                queryParams: {id}
            });
        } else {
            this.router.navigate([this.getBaseRoute(), this.type, 'edit-' + this.type], {
                queryParams: {id}
            });
        }
    }

    getClientName(item: any): string {
        if (this.expandedRowId === item.id && this.expandedDocument) {
            const client = this.expandedDocument.clients?.[0]
                || this.expandedDocument.client_data
                || this.expandedDocument.client;
            return this.resolveVenteClientLabel(client) || '--';
        }
        if (item.clientName && item.clientName !== '--') {
            return item.clientName;
        }
        if (item.nomClient) {
            return item.nomClient;
        }

        return '--';
    }
    getPartyName(item: any): string {
        if (this.type === 'inventaire') {
            const doc = item.fullData || item;
            const client = doc.clients?.[0]
                || doc.client_data
                || doc.client;
            return this.resolveVenteClientLabel(client) || '--';
        }
        
        if (this.expandedRowId === item.id && this.expandedDocument) {
            if (this.baseRoute === '/vente') {
                const client = this.expandedDocument.clients?.[0]
                    || this.expandedDocument.client_data
                    || this.expandedDocument.client;
                return this.resolveVenteClientLabel(client) || '--';
            } else {
                const fournisseur = this.expandedDocument.fornisseurs?.[0]
                    || this.expandedDocument.fournisseur_data;
                return fournisseur?.nom_entreprise || '--';
            }
        }
        if (this.baseRoute === '/vente') {
            if (item.clientName && item.clientName !== '--') {
                return item.clientName;
            }
            if (item.nomClient) {
                return item.nomClient;
            }
            const fd = item.fullData || item;
            const c = fd?.clients?.[0] || fd?.client_data || fd?.client;
            return this.resolveVenteClientLabel(c) || '--';
        } else {
            const fullData = item.fullData;
            if (fullData?.fornisseurs?.[0]?.nom_entreprise) {
                return fullData.fornisseurs[0].nom_entreprise;
            }
            return '--';
        }
    }

    /** Affiche l'entreprise pour un client pro ; nom/prénom pour un particulier. */
    private resolveVenteClientLabel(c: any): string {
        if (!c) {
            return '';
        }
        const type = String(c.type || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const isPro = type === 'professionnel' || type === 'negoce' || type === 'patente' || type === 'entreprise';
        const isParticulier = type === 'individuel' || type === 'particulier' || type === 'materiel';
        const entreprise = String(c.nom_entreprise || c.raison_social || '').trim();
        const nomPrenom = String(c.nom_prenom || '').trim();
        const composed = [c.prenom, c.nom].filter(Boolean).join(' ').trim();
        const nomClient = String(c.nom_client || c.nomClient || '').trim();

        const candidates = isPro
            ? [entreprise, nomClient, nomPrenom, composed]
            : isParticulier || type
              ? [nomPrenom, composed, nomClient, entreprise]
              : [entreprise, nomPrenom, composed, nomClient];

        let fallback = '';
        for (const raw of candidates) {
            const label = String(raw || '').trim();
            if (!label) {
                continue;
            }
            if (!this.looksLikeEmailValue(label)) {
                return label;
            }
            if (!fallback) {
                fallback = label;
            }
        }
        return fallback;
    }

    /** Recherche liste : entreprise / raison sociale / code — pas l'email. */
    private matchesClientEntrepriseSearch(item: any, term: string): boolean {
        const t = String(term || '').trim().toLowerCase();
        if (!t) {
            return true;
        }
        const fd = item?.fullData || item;
        const c = fd?.clients?.[0] || fd?.client_data || fd?.client;
        const hay = [
            item?.clientName,
            item?.matricule,
            c?.nom_entreprise,
            c?.raison_social,
            c?.code_client,
            c?.identifiant_unique,
            c?.numero_identification_fiscale,
            c?.nom_prenom
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase()
            .replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, ' ');
        return hay.includes(t);
    }

    private looksLikeEmailValue(value: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    getEntrepotInventaire(item: any): string {
        if (this.type !== 'inventaire') {
            return '--';
        }

        const doc = item?.fullData || item;
        if (!doc) {
            return '--';
        }

        const existing = doc.entrepot;
        if (existing) {
            const nom = typeof existing === 'string' ? existing : existing?.nom;
            if (nom) {
                const eid = doc.entrepot_id || existing?.id;
                if (eid) {
                    this.entrepotsCache.set(Number(eid), String(nom));
                }
                return String(nom);
            }
        }

        const entrepotIdRaw = doc.entrepot_id || doc.entrepot?.id;
        const entrepotId = entrepotIdRaw != null ? Number(entrepotIdRaw) : null;
        if (entrepotId != null && !Number.isNaN(entrepotId) && this.entrepotsCache.has(entrepotId)) {
            return this.entrepotsCache.get(entrepotId)!;
        }

        if (entrepotId != null && !Number.isNaN(entrepotId) && this.stationId) {
            const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
            const userId = currentUser?.id;
            if (userId) {
                this.loadEntrepot(entrepotId, userId, 'initial', doc);
            }
            return 'Chargement...';
        }

        return '--';
    }

    getEntrepotInitial(item: any): string {
        if (this.type !== 'bon-transfert') {
            return '--';
        }
        
        const doc = item.fullData || item;
        if (doc.entrepot) {
            const nom = typeof doc.entrepot === 'string' 
                ? doc.entrepot 
                : doc.entrepot?.nom;
            if (nom) {
                if (doc.entrepot_id) {
                    this.entrepotsCache.set(doc.entrepot_id, nom);
                }
                return nom;
            }
        }
        const entrepotId = doc.entrepot_id;
        if (entrepotId && this.entrepotsCache.has(entrepotId)) {
            return this.entrepotsCache.get(entrepotId)!;
        }
        if (entrepotId && this.stationId) {
            const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
            const userId = currentUser?.id;
            if (userId) {
                this.loadEntrepot(entrepotId, userId, 'initial', doc);
            }
            return 'Chargement...';
        }
        
        return '--';
    }

    getEntrepotDestination(item: any): string {
        if (this.type !== 'bon-transfert') {
            return '--';
        }
        
        const doc = item.fullData || item;
        if (doc.entrepot_destination) {
            const nom = typeof doc.entrepot_destination === 'string' 
                ? doc.entrepot_destination 
                : doc.entrepot_destination?.nom;
            if (nom) {
                const entrepotDestId = doc.entrepot_dest_id || doc.entrepot_destination_id;
                if (entrepotDestId) {
                    this.entrepotsCache.set(entrepotDestId, nom);
                }
                return nom;
            }
        }
        const entrepotDestId = doc.entrepot_dest_id || doc.entrepot_destination_id;
        if (entrepotDestId && this.entrepotsCache.has(entrepotDestId)) {
            return this.entrepotsCache.get(entrepotDestId)!;
        }
        if (entrepotDestId && this.stationId) {
            const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
            const userId = currentUser?.id;
            if (userId) {
                this.loadEntrepot(entrepotDestId, userId, 'destination', doc);
            }
            return 'Chargement...';
        }
        
        return '--';
    }

    private loadEntrepot(entrepotId: number, userId: number, type: 'initial' | 'destination', doc: any): void {
        if (!entrepotId || !userId || !this.stationId) {
            return;
        }

        // Éviter les chargements multiples du même entrepôt
        if (this.entrepotsCache.has(entrepotId)) {
            return;
        }

        this.warehouseService.detailEntrepot(entrepotId, userId, this.stationId).subscribe({
            next: (response: any) => {
                const entrepotData = response?.entrepot || response?.data || response;
                if (entrepotData && entrepotData.nom) {
                    this.entrepotsCache.set(entrepotId, entrepotData.nom);
                    if (type === 'initial') {
                        doc.entrepot = entrepotData;
                    } else {
                        doc.entrepot_destination = entrepotData;
                    }
                    this.cdr.detectChanges();
                }
            },
            error: (err) => {
                this.entrepotsCache.set(entrepotId, '--');
            }
        });
    }

    showApercu(item: any): void {
        if (!item?.id) {
            this.toastr.error('Document invalide');
            return;
        }

        if (this.selectedItem?.id === item.id && this.isApercuVisible) {
            this.closeApercu();
            return;
        }

        this.isApercuVisible = true;
        this.isLoadingDocument = true;

        this.customizerService.open({
            showTotals: true,
            showContactInfo: true,
            showDescription: false,
            noteText: ''
        });
        this.documentService.getDocumentById(item.id).subscribe({
            next: (response) => {
                const documentComplet = response?.data?.document || response;
                this.documentService.setCurrentPreviewDocument(documentComplet);

                this.selectedDocumentFull = documentComplet;
                this.isLoadingDocument = false;
                this.cdr.detectChanges();
            },
            error: () => {
                this.isLoadingDocument = false;
            }
        });
    }

    closeApercu(): void {
        this.isApercuVisible = false;
        this.selectedItem = null;
        this.selectedDocumentFull = null;
        this.customizerService.close();
        this.cdr.detectChanges();
    }


}
